import React, { useEffect, useState, useMemo } from 'react'
import { Render, FieldLabel, DropZone, Button } from "@measured/puck";
import ReactEcharts from "echarts-for-react";
import Svg from '../../../common/Svg';

import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getSurveyReport, getSurveySectionData, getSurveyResult, getSurveyResultPreview, getSurveyReportPreview } from '../../store/actions/surveyFormAction';
import { toast } from 'react-toastify';
import ReportPage from './components/ReportPage';
import ReportRenderer from './components/ReportRenderer';
import theme__ from '../../../common/ThemeSettings';
import ReactDOMServer from 'react-dom/server';
import { v4 as uuidv4 } from 'uuid'; // For generating unique keys
import parse from 'html-react-parser';

import '../landingPage/styles/style.css';
import '../landingPage/styles/puck-sections.css';
import './styles/report-style.css';

import icon2 from "./images/icon.svg";
import pucksettings from '../../../common/PuckEditorSettings'
import AWS from 'aws-sdk'
import axios from 'axios';
AWS.config.update({
    accessKeyId: process.env.AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY
})
const S3_BUCKET = 'survey-bis';
const REGION = process.env.AWS_REGION;
const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
});



const PieChartOptions = {
    tooltip: {
        trigger: 'item'
    },

    grid: {
        left: '30%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    series: [
        {
            // name: 'Actual Benefits with Vodafone',
            type: 'pie',
            radius: '50%',
            color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
            data: [
                { value: 1048, name: 'Lower Costs' },
                { value: 735, name: 'Increase Productivity' },
                { value: 580, name: 'Enable Business' },

            ],
            top: "0%",
            radius: ["0%", "100%"],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};

const BarChartOptions = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },

    grid: {
        left: '0%',
        top: '5%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: [
        {
            type: 'category',
            data: ['2022', '2023', '2024']
        }
    ],
    yAxis: [
        {
            type: 'value'
        }
    ],
    series: [

        {
            name: 'Lower Costs',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#9C2AA0' // Apply purple color here
            },
            data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
            name: 'Increase Productivity',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#EB9700' // Apply orange color here
            },
            data: [220, 182, 191, 234, 290, 330, 310]
        },
        {
            name: 'Enable Business',
            type: 'bar',
            stack: 'Ad',
            barWidth: '60',
            emphasis: {
                focus: 'series'
            },
            itemStyle: {
                color: '#00B0CA' // Apply cyan color here
            },
            data: [150, 232, 201, 154, 190, 330, 410]
        },
    ]
};

const GaugeChartOptiopns = {
    series: [
        {
            type: "gauge",
            center: ["50%", "65%"],
            radius: "90%",
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 100,
            splitNumber: 20,
            itemStyle: {
                color: "#F47D32"
            },
            progress: {
                show: true,
                width: 15
            },

            pointer: {
                show: false
            },
            axisLine: {
                lineStyle: {
                    width: 15
                }
            },
            axisTick: {
                distance: -30,
                splitNumber: 5,
                lineStyle: {
                    width: 2,
                    color: "#EA7926"
                }
            },
            splitLine: {
                distance: -40,
                length: 14,
                lineStyle: {
                    width: 3,
                    color: "#EA7926"
                }
            },
            axisLabel: {
                distance: -25,
                color: "#fff",
                fontSize: 16
            },
            anchor: {
                show: false
            },
            title: {
                show: false
            },
            detail: {
                valueAnimation: true,
                width: "60%",
                lineHeight: 40,
                borderRadius: 8,
                offsetCenter: [0, '-15%'],
                fontSize: 50,
                fontWeight: "bolder",
                formatter: "{value}%",
                color: "inherit"
            },
            data: [
                {
                    value: 30
                }
            ]
        }
    ]
};
// Function to update GaugeChartOptions
function updateChartOptions(options, gaugeValue, chartColor, textColor, min, max, interval) {
    if (!options || !options.series || !options.series[0] || !options.series[0].axisLine || !options.series[0].axisTick || !options.series[0].splitLine || !options.series[0].axisLabel || !options.series[0].detail) {
        return options; // Return original options if critical parts are not defined
    }
    if (gaugeValue !== undefined) {
        options.series[0].data[0].value = gaugeValue;
    }
    if (chartColor) {
        options.series[0].itemStyle.color = chartColor;

    }

    if (textColor) {
        options.series[0].axisLabel.color = textColor;
        options.series[0].splitLine.lineStyle.color = textColor;
        options.series[0].axisTick.lineStyle.color = textColor;
    }

    if (min !== undefined && max !== undefined) {
        options.series[0].min = min;
        options.series[0].max = max;
    }

    if (interval !== undefined) {
        options.series[0].splitNumber = Math.ceil((max - min) / interval);
    }

    return options;
}
const chartStyle = {
    height: '300px',
    width: '100%',
}
const chartStyleGauge = {
    height: '300px',
    width: '400px',
}

// Utility function to replace dynamic expressions like #[key]# with values from quesDom
function replaceDynamicExpressions(str, quesDom) {
    return str.replace(/#\[(.*?)\]#/g, (_, key) => quesDom[key] ?? '');
}

export default function ReportPuck({ SRID }) {
    const [flagLandingPage, setFlagLandingPage] = useState(0);


    //States
    const [innerHtml1, setInnerHtml1] = useState(null)
    // const [innerHtml2, setInnerHtml2] = useState(null)
    const [ids1, setIds1] = useState(null)
    // const [ids2, setIds2] = useState(null)
    const [innerCss1, setInnerCss1] = useState(null)
    // const [innerCss2, setInnerCss2] = useState(null)
    const [innerHtmlFlag, setInnerHtmlFlag] = useState(0)
    const { survey_id, ss_id, srid, isPreview } = useParams();
    const [isMobile, setIsMobile] = useState(false)
    const [leadArray, setLeadArray] = useState([])
    const [queArray, setQueArray] = useState([])
    const [surveyArray, setSurveyArray] = useState([])
    const [sectionArray, setSectionArray] = useState([])
    const [theme, setTheme] = useState(-1);
    const [themeSet, setThemeSet] = useState([]);
    const [logoImage, setLogoImage] = useState('');
    const [widgetLists, setWidgetLists] = useState([]);
    const [graphVar, setGraphVar] = useState({});


    const dispatch = useDispatch()
    const surveyReportData = useSelector((state) => state?.survey?.surveyData?.surveyReport)
    const result = useSelector((state) => state?.survey?.surveyData?.surveyResult)
    const surveySections = useSelector((state) => state?.survey?.surveyData?.surveySections)


    //Functionalities
    const decodeHTMLEntities = (text) => {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = text;
        return textArea.value;
    }
    //Effects
    useEffect(() => {
        const payload = {
            survey_id,
            srid: srid ?? SRID,
            ss_id
        }
        if (isPreview == 1) {
            dispatch(getSurveyReportPreview(payload))
        } else {
            dispatch(getSurveyReport(payload))
        }


        // Check if the window width is less than 768px (i.e., a mobile device)
        setIsMobile(window.innerWidth < 576);

        // Update the isMobile state variable whenever the window is resized
        const handleResize = () => setIsMobile(window.innerWidth < 576);
        window.addEventListener('resize', handleResize);

        dispatch(getSurveySectionData({
            "survey_id": survey_id
        }))

        return () => window.removeEventListener('resize', handleResize);

    }, [SRID, srid, ss_id, survey_id])

    useEffect(() => {
        if (survey_id && ss_id) {
            //console.log(isPreview);
            if (isPreview == 1) {
                //console.log(survey_id);
                //console.log(ss_id);
                dispatch(getSurveyResultPreview({ survey_id, ss_id }))
            } else {
                dispatch(getSurveyResult({ survey_id, ss_id }))
            }

        }
    }, [survey_id, ss_id])

    useEffect(() => {
        if (surveyReportData.html) {
            setTheme(surveyReportData.surveyDom.theme_selected);
            // setTheme(1);
            setThemeSet(theme__[theme]);
            if (theme == 0 || theme == null) {
                setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/a0e0d1d3-f39b-4a07-b7ec-8bea0c47c919_1705681254869_download.png');
            } else if (theme >= 1) {
                setLogoImage('https://survey-bis.s3.ap-south-1.amazonaws.com/logo/' + theme + '.svg');
            }
            const create1 = createPages(1)
            // const create2 = createPages(2)
            setInnerHtml1(create1.objs)
            setInnerCss1(create1.cssObjs)
            // setInnerHtml2(create2.objs)
            // setInnerCss2(create2.cssObjs)
            setIds1(create1.idObj)
            // setIds2(create2.idObj)
            setInnerHtmlFlag(1)
        }
        if (innerHtmlFlag == 1) {
            setLeadArray(surveyReportData.leadDom);
            setQueArray(surveyReportData.quesDom);
            setSurveyArray(surveyReportData.surveyDom);
        }
    }, [innerHtmlFlag, surveyReportData])


    let createPages = function (type) {
        const objs = []
        const cssObjs = []
        const idObj = []
        Object.keys(surveyReportData.pages ?? {})?.forEach(function (key, index) {
            // if ((type == 1 && key < 6) || (type == 2 && key > 6)) {
            surveyReportData.pages[key] = decodeHTMLEntities(surveyReportData.pages[key] ?? '')

            for (let x in surveyReportData.leadDom) {

                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[leadForm:' + x + ']#', surveyReportData.leadDom[x]);
            }

            for (let x in surveyReportData.quesDom) {
                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[' + x + ']#', surveyReportData.quesDom[x]);
                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('&amp;nbsp;&amp;nbsp;', '&lt;br&gt;&amp;nbsp;&lt;/br&gt;');
                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('&amp;nbsp;&amp;nbsp;&amp;nbsp;', '&lt;br&gt;&amp;nbsp;&lt;/br&gt;');
            }



            for (let x in surveyReportData.surveyDom) {
                let y = x;
                if (x == 'topic_name') {
                    y = 'title';
                }
                if (x == 'company_name') {
                    y = 'companyTitle';
                }

                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[survey:' + y + ']#', surveyReportData.surveyDom[x]);
            }

            for (let x in surveyReportData.quesVariableValues) {
                let searchString = `#[${x}`;
                if (surveyReportData.pages[key].includes(searchString)) {
                    const valuesOfSpecificKey = surveyReportData.quesVariableValues[x];
                    valuesOfSpecificKey.map((val) => {
                        if (surveyReportData.pages[key].includes(Object.keys(val)[1])) {
                            surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll(`${searchString}:${Object.keys(val)[1]}]#`, Object.values(val)[1]);
                        }
                    })
                }
            }
            for (let x in surveyReportData.solutions) {
                surveyReportData.pages[key] = (surveyReportData.pages[key]).replaceAll('#[' + x + ']#', surveyReportData.solutions[x]);
            }
            objs.push(surveyReportData.pages[key])
            cssObjs.push(surveyReportData.css[key])
            idObj.push(key)
        });
        return { objs, cssObjs, idObj }
    }

    const sectionColors = ['#000', '#000', '#000', '#000', '#000']

    //Options and style
    const style = {
        height: '400px',
        //width: '100%',
        // add the chart-container class
        //className: 'chart-container',
    }

    // const options = useMemo(() => {

    //     //Intervals and max value
    //     const interval = Number(result?.graph_interval ?? 3)
    //     const intervalCount = Number(result?.graph_interval_count ?? 100)
    //     const maxValue = interval * intervalCount

    //     //Functionalities
    //     const getIndicator = (name, colorIndex) => {
    //         return { name: name, max: maxValue, color: sectionColors[colorIndex] }
    //     }

    //     //Get sections and indicators 
    //     let indicators = []
    //     let values = []
    //     const sectionWithScore = result?.section_maturity_score

    //     Object.keys(sectionWithScore ?? {})?.forEach((key, index) => {
    //         let name__ = surveySections[key].name;
    //         do {
    //             name__ = (name__).replace(' ', '\n')
    //         } while ((name__).includes(" "));
    //         indicators.push(getIndicator(name__, index))
    //         values.push(Number(sectionWithScore[key]))
    //     })

    //     // Object.keys(sectionWithScore ?? {})?.forEach((key, index) => {
    //     //     indicators.push(getIndicator(surveySections[key]?.name, index))
    //     //     values.push(Number(sectionWithScore[key]))

    //     // })

    //     indicators.push(indicators.shift())

    //     //Return if data
    //     if (indicators.length > 0 && values.length > 0) {
    //         values.push(values.shift())

    //         // for (let chartKey in widgetLists) {
    //         // return widgetLists.map((value, chartKey) => {
    //         //     let graphVar = JSON.parse(widgetLists[chartKey].su_widget_data)
    //         //     if (widgetLists[chartKey].su_widget_type == 2) {
    //         //         //graphVar.radar.indicator = indicators.reverse()
    //         //         //graphVar.series[0].data[0].value = values.reverse()

    //         //         for (let key in graphVar.radar.indicator) {
    //         //             graphVar.radar.indicator[key].max = maxValue;
    //         //             graphVar.radar.indicator[key].color = "#B44949"
    //         //         }

    //         //         let graphVar_values = [];
    //         //         for (let ind in graphVar.series[0].data[0].value) {
    //         //             let lower_name = graphVar.series[0].data[0].value[ind];
    //         //             lower_name = lower_name.replace("#", "");
    //         //             lower_name = lower_name.replace("#", "");
    //         //             lower_name = lower_name.replace("[", "");
    //         //             lower_name = lower_name.replace("]", "");
    //         //             lower_name = lower_name.replaceAll(" ", "_");
    //         //             // [lower_name + '_maturity_percentage']
    //         //             // Object.keys(surveySections ?? {})?.map((key, index) => {
    //         //             // //     [lower_name + '_maturity_percentage']
    //         //             // })
    //         //             for (let prop in surveySections) {
    //         //                 const surveySection = surveySections[prop];
    //         //                 let lower_name_new = surveySection.name.toLowerCase();
    //         //                 lower_name_new = lower_name_new.replaceAll(" ", "_")
    //         //                 lower_name_new = lower_name_new + "_maturity_percentage";
    //         //                 if (lower_name_new == lower_name) {
    //         //                     //console.log("lower_name_new", lower_name_new, lower_name, sectionWithScore[prop])
    //         //                     graphVar_values.push(sectionWithScore[prop]);
    //         //                 }
    //         //                 // if (surveySections.hasOwnProperty(prop)) {
    //         //                 //     // if (object[prop] === value)
    //         //                 //     //     return prop;
    //         //                 //     console.log(prop.name)
    //         //                 // }
    //         //             }

    //         //             // console.log("lower_name",lower_name,surveySections);

    //         //         }

    //         //         graphVar.series[0].data[0].value = graphVar_values
    //         //         graphVar.radar.splitNumber = intervalCount
    //         //         graphVar.radar.name.textStyle.fontSize = isMobile ? 12 : 16;
    //         //         graphVar.radar.name.textStyle.lineHeight = isMobile ? 14 : 18;
    //         //         for (const i in graphVar.title) {
    //         //             let title = graphVar.title;
    //         //             let name_has_value = title.text;
    //         //             name_has_value.replace("#", "")
    //         //             name_has_value.replace("#", "")
    //         //             name_has_value.replace("[", "")
    //         //             name_has_value.replace("]", "")
    //         //             // Here Find the title and replace here

    //         //             // for(const dbIndex of dbs){
    //         //             //     if(dbIndex.name == name_has_value){
    //         //             //         graphVar.title.text = dbIndex.value;
    //         //             //     }
    //         //             // }                
    //         //         }
    //         //     } else if (widgetLists[chartKey].su_widget_type == 1) {
    //         //         let graphVar_values = [];
    //         //         for (let ind in graphVar.series[0].data) {
    //         //             let lower_name = graphVar.series[0].data[ind];
    //         //             lower_name = lower_name.replace("#", "");
    //         //             lower_name = lower_name.replace("#", "");
    //         //             lower_name = lower_name.replace("[", "");
    //         //             lower_name = lower_name.replace("]", "");
    //         //             lower_name = lower_name.replaceAll(" ", "_");
    //         //             for (let prop in surveySections) {
    //         //                 const surveySection = surveySections[prop];
    //         //                 let lower_name_new = surveySection.name.toLowerCase();
    //         //                 lower_name_new = lower_name_new.replaceAll(" ", "_")
    //         //                 lower_name_new = lower_name_new + "_maturity_percentage";
    //         //                 if (lower_name_new == lower_name) {
    //         //                     graphVar_values.push(sectionWithScore[prop]);
    //         //                 }
    //         //             }
    //         //         }

    //         //         graphVar.series[0].data = graphVar_values
    //         //     }
    //         //     return graphVar;
    //         // });
    //     }


    //     return [];

    // }, [surveySections, result, isMobile, themeSet, widgetLists])

    // Config for Pumck Editor
    const config = {
        components: {

            //Report Pages
            //Report Pages
            ReportBanner: {
                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Description: {
                        type: "object",
                        objectFields: {
                            text: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes'],
                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight'],
                            },

                        },
                    },
                    Align: {
                        label: "Vertical Alignment",
                        type: "select",
                        options: pucksettings['VAlign'],
                    },
                    image: {
                        type: "custom",
                        label: "Add image (1920 × 1024 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportBannerImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };

                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepoBannerImage'
                                        name={name}
                                        onChange={handleReportBannerImage}
                                    />
                                    <label htmlFor="uploadRepoBannerImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },
                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepoLogoImage'
                                        name={name}
                                        onChange={handleReportLogoImage}
                                    />
                                    <label htmlFor="uploadRepoLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },

                    },
                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "<span class='text-theme-primary'><span class='text-theme-primary'>#[leadForm:firstName]# #[leadForm:lastName]#</span>, your company <span class='text-theme-primary'>#[leadForm:company]#</span> is at <span class='text-theme-primary'>'#[maturity_stage]#'</span> stage</span>",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },

                    Description: {
                        text: "<span class='text-theme-primary'>#[survey:title]# Assessment</span>",
                        descriptionFont: "fs-18",
                    },
                    Align: "align-items-end",
                    image: "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png",
                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, Description, image, logo, Align }) => {

                    return (
                        <>
                            <div className={`report-banner report-build-wrapper d-flex ${Align}`} style={{ backgroundImage: `url("${image}")` }}>
                                <div className="container">
                                    <div className="text wrapper">
                                        <p className={Description.descriptionFont}><div dangerouslySetInnerHTML={{ __html: Description.text }} /></p>
                                        <h1 className={`${Heading.fontWeight} ${Heading.titleFont}`}><div dangerouslySetInnerHTML={{ __html: Heading.title }} /></h1>
                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportWhatsInside: {

                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight'],

                            },

                        },
                    },

                    items: {
                        type: "array",
                        label: "Sections",
                        arrayFields: {
                            Title: { type: "text" },
                            CouterFontSize: {
                                label: "Counter font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            CounterFontWeight: {
                                label: "Counter font weight",
                                type: "select",
                                options: pucksettings['fontweight'],

                            },
                            TitleFontSize: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },

                        },
                        getItemSummary: (item) => item.Title || "Section",
                        defaultItemProps: {
                            Title: "Section title",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleInsideLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadInsideLogoImage'
                                        name={name}
                                        onChange={handleInsideLogoImage}
                                    />
                                    <label htmlFor="uploadInsideLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "What's Inside",
                        fontWeight: "fw-700",
                        CounterFontWeight: "fw-400",
                        titleFont: "fs-45",
                    },

                    items: [
                        {
                            Title: "Introduction",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                        {
                            Title: "Methodology",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                        {
                            Title: "#[leadForm:company]# assessment and recommendations",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                        {
                            Title: "#[leadForm:company]# #[survey:title]# Services",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                        {
                            Title: "Your responses to the assessment",
                            CouterFontSize: "fs-100",
                            CounterFontWeight: "fw-400",
                            TitleFontSize: "fs-20",
                        },
                    ],

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, logo, items }) => {

                    return (
                        <>

                            <div className="report-whats-inside report-build-wrapper">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        </div>
                                        <div className="inside-main">
                                            <div className="row">
                                                {items.map((item, i) => (

                                                    <div className="col-lg-4 col-md-4" key={i}>
                                                        <div className="inside-wrapper">
                                                            <h4 className={`${item.CouterFontSize} ${item.CounterFontWeight}`}>{String(i + 1).padStart(2, '0')}</h4>
                                                            <p className={`${item.TitleFontSize}`}>{item.Title}</p>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    )

                },
            },

            ReportIntroduction: {

                fields: {
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    items: {
                        type: "array",
                        label: "Sections",
                        arrayFields: {
                            Title: { type: "text" },
                            TitleFontSize: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Title font weight",
                                type: "select",
                                options: pucksettings['fontweight']


                            },
                            Description: { type: "textarea" },
                            DescriptionFontSize: {
                                label: "Description font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                        getItemSummary: (item) => item.Title || "Section",
                        defaultItemProps: {
                            Title: "Section title",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            Description: "Section description",
                            DescriptionFontSize: "fs-15",
                        },
                    },
                    image: {
                        type: "custom",
                        label: "Add image (742 × 1024 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportMethoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };

                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotMethImage'
                                        name={name}
                                        onChange={handleReportMethoImage}
                                    />
                                    <label htmlFor="uploadRepotMethImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },
                    // Desclaimer: {
                    //     type: "object",
                    //     label: "Disclaimer",
                    //     objectFields: {
                    //         title: {
                    //             type: "custom",
                    //             label: "Title",
                    //             render: ({ name, onChange, value, field }) => (
                    //                 <>
                    //                     <FieldLabel label={field.label}></FieldLabel>
                    //                     <textarea
                    //                         defaultValue={value}
                    //                         className='form-control'
                    //                         name={name}
                    //                         onChange={(e) => onChange(e.currentTarget.value)}

                    //                     />

                    //                 </>
                    //             ),
                    //         },
                    //         TitleFont: {
                    //             label: "Font size",
                    //             type: "select",
                    //             options: pucksettings['fontsizes']

                    //         },
                    //         fontWeight: {
                    //             label: "Font weight",
                    //             type: "select",
                    //             options: pucksettings['fontweight']

                    //         },

                    //         description: {
                    //             type: "custom",
                    //             label: "Text",
                    //             render: ({ name, onChange, value, field }) => (
                    //                 <>
                    //                     <FieldLabel label={field.label}></FieldLabel>
                    //                     <textarea
                    //                         defaultValue={value}
                    //                         className='form-control'
                    //                         name={name}
                    //                         onChange={(e) => onChange(e.currentTarget.value)}

                    //                     />
                    //                 </>
                    //             ),
                    //         },
                    //         descriptionFont: {
                    //             label: "Font size",
                    //             type: "select",
                    //             options: pucksettings['fontsizes']

                    //         },
                    //     },
                    // },


                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleIntroLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadIntroLogoImage'
                                        name={name}
                                        onChange={handleIntroLogoImage}
                                    />
                                    <label htmlFor="uploadIntroLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );

                        }

                    },

                },
                defaultProps: {
                    Heading: {
                        title: "01 Introduction",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        description: "Thank you for participating in the #[survey:companyTitle]# #[survey:title]#. We have evaluated various aspects of your Technology Integration, Skills and Expertise, Threat Intelligence Utilization, Budget and Resource Allocation, Incident Response and Coordination, indicators, based on your valuable responses. We are pleased to present you with the #[survey:companyTitle]# #[survey:title]# report.",
                        descriptionFont: "fs-15",
                    },
                    items: [
                        {
                            Title: "The Report",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "This report aims to provides you with a summary of our assessment, including scores for each question and a detailed analysis of your business's readiness in key areas. Additionally, we have included valuable recommendations on addressing any readiness gaps and optimising your business's #[survey:companyTitle]# transformation journey."
                        },
                        {
                            Title: "#[survey:companyTitle]#",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "#[survey:companyTitle]# is a global leader in digital infrastructure services, providing transformative solutions to 300 of the Fortune 500 companies. With solutions for the cloud, mobility, IoT, collaboration, security, and network services, they fuel digital transformation and enable borderless growth. Their global network spans across 190+ countries, handling 30% of internet routes and connecting to the majority of cloud giants and mobile subscribers. "
                        },

                    ],
                    image: "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png",

                    // Desclaimer: {
                    //     title: "Disclaimer",
                    //     TitleFont: "fs-16",
                    //     fontWeight: "fw-700",
                    //     description: "This report is for informational use and not professional advice. It's based on customer data and subject to change. #[survey:companyTitle]# disclaims all warranties regarding this report. Reliance on this report is at your own risk. #[survey:companyTitle]# is not liable for any loss or damage from using this report. The report may be temporarily unavailable due to technical issues. By using this report, you agree to indemnify #[survey:companyTitle]# against any claims or losses related to its use.",
                    //     descriptionFont: "fs-10",
                    // },

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",


                },
                render: ({ Heading, logo, items, Text, image }) => {

                    return (
                        <>



                            <div className="report-build-wrapper report-right-image-section">
                                <div className="text wrapper flex-grow-1">
                                    <div className="rep-heading-page">
                                        <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    </div>

                                    <div className="text-part">

                                        <div className="report-text pb-3">
                                            <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                        </div>
                                        <div className="list-text report-text">
                                            {items.map((item, i) => (

                                                <div className="list-wrap pb-2" key={i}>
                                                    <h6 className={`${item.TitleFontSize} ${item.TitleFontWeight}`}>{item.Title}</h6>
                                                    <p className={`${item.DescriptionFontSize}`}>{item.Description}</p>

                                                </div>
                                            ))}


                                        </div>
                                    </div>
                                </div>
                                <div className="image-part" style={{ backgroundImage: `url("${image}")` }}>
                                </div>

                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },
            // Table can be removed
            IntroductionTable: {
                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Table: {
                        type: "object",
                        objectFields: {

                            Columns: {
                                type: "number",
                                label: "Columns per Row",
                            },

                            FirstRow: {
                                type: "custom",
                                label: "First Row as Heading",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                            <div className="check-switch">
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={value}
                                                    name={name}
                                                    onChange={(e) => onChange(e.currentTarget.checked)} />
                                            </div>
                                        </div>

                                    </>
                                ),
                            },
                            LastRow: {
                                type: "custom",
                                label: "Last Row as Result",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <FieldLabel className='label-wrp' label={field.label}></FieldLabel>
                                            <div className="check-switch">
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={value}
                                                    name={name}
                                                    onChange={(e) => onChange(e.currentTarget.checked)} />
                                            </div>
                                        </div>

                                    </>
                                ),
                            },
                        },

                    },

                    ColumnSettings: {
                        type: "object",
                        objectFields: {
                            FirstColSpan: {
                                type: "text",
                                label: "1st column width",
                            },
                            SecondColSpan: {
                                type: "text",
                                label: "2nd Column width",
                            },
                            ThirdColSpan: {
                                type: "text",
                                label: "3rd Column width",
                            },
                            FourthColSpan: {
                                type: "text",
                                label: "4th Column width",
                            },
                            FifthColSpan: {
                                type: "text",
                                label: "5th Column width",
                            },
                            SixthColSpan: {
                                type: "text",
                                label: "6th Column width",
                            },

                        },

                    },


                    Headings: {
                        type: "object",
                        objectFields: {
                            Cell1: {
                                type: "custom",
                                label: "Cell 1",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell2: {
                                type: "custom",
                                label: "Cell 2",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell3: {
                                type: "custom",
                                label: "Cell 3",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell4: {
                                type: "custom",
                                label: "Cell 4",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell5: {
                                type: "custom",
                                label: "Cell 5",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell6: {
                                type: "custom",
                                label: "Cell 6",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                        },
                    },

                    items: {
                        type: "array",
                        label: "Rows",
                        arrayFields: {
                            Cell1Data: {
                                type: "custom",
                                label: "Cell 1 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                            Cell2Data: {
                                type: "custom",
                                label: "Cell 2 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),

                            },


                            Cell3Data: {
                                type: "custom",
                                label: "Cell 3 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                            Cell4Data: {
                                type: "custom",
                                label: "Cell 4 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),

                            },
                            Cell5Data: {
                                type: "custom",
                                label: "Cell 5 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell6Data: {
                                type: "custom",
                                label: "Cell 6 Data",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                        },
                        getItemSummary: (item) => item.Cell1Data || "Row",
                        defaultItemProps: {
                            Title: "Row",
                            Cell1Data: "Text here",
                            Cell2Data: "1",
                            Cell3Data: "1",
                            Cell4Data: "1",
                            Cell5Data: "1",
                            Cell6Data: "1%",

                        },

                    },

                    Calculations: {
                        type: "object",
                        objectFields: {
                            Cell1: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Cell2: {
                                type: "custom",
                                label: "Value",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                        },
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Table: {
                        Rows: 5,
                        Columns: 6,
                        FirstRow: true,
                        LastRow: true,
                    },
                    ColumnSettings: {
                        FirstColSpan: '190',
                        SecondColSpan: '80',
                        ThirdColSpan: '80',
                        FourthColSpan: '80',
                        FifthColSpan: '80',
                        SixthColSpan: '69',
                    },
                    Headings: {
                        Cell1: "",
                        Cell2: "Question 1",
                        Cell3: "Question 2",
                        Cell4: "Question 3",
                        Cell5: "Question 4",
                        Cell6: "Score",
                    },
                    items: [
                        {
                            Cell1Data: "Technology Integration",
                            Cell2Data: "#[que_1_marks]#",
                            Cell3Data: "#[que_2_marks]#",
                            Cell4Data: "#[que_3_marks]#",
                            Cell5Data: "#[que_4_marks]#",
                            Cell6Data: "#[section_1_maturity_percentage]#",
                        },
                        {
                            Cell1Data: "Skills and Expertise",
                            Cell2Data: "#[que_5_marks]#",
                            Cell3Data: "#[que_6_marks]#",
                            Cell4Data: "#[que_7_marks]#",
                            Cell5Data: "#[que_8_marks]#",
                            Cell6Data: "#[section_2_maturity_percentage]#",
                        },
                        {
                            Cell1Data: "Threat Intelligence Utilization	",
                            Cell2Data: "#[que_9_marks]#",
                            Cell3Data: "#[que_10_marks]#",
                            Cell4Data: "#[que_11_marks]#",
                            Cell5Data: "#[que_12_marks]#",
                            Cell6Data: "#[section_3_maturity_percentage]#",
                        },
                        {
                            Cell1Data: "Budget and Resource Allocation	",
                            Cell2Data: "#[que_13_marks]#",
                            Cell3Data: "#[que_14_marks]#",
                            Cell4Data: "#[que_15_marks]#",
                            Cell5Data: "#[que_16_marks]#",
                            Cell6Data: "#[section_4_maturity_percentage]#",
                        },
                        {
                            Cell1Data: "Technology Integration",
                            Cell2Data: "#[que_17_marks]#",
                            Cell3Data: "#[que_18_marks]#",
                            Cell4Data: "#[que_19_marks]#",
                            Cell5Data: "#[que_20_marks]#",
                            Cell6Data: "#[section_5_maturity_percentage]#",
                        },
                        // {
                        //     Cell1Data: "Incident Response and Coordination	",
                        //     Cell2Data: "#[que_21_marks]#",
                        //     Cell3Data: "#[que_22_marks]#",
                        //     Cell4Data: "#[que_23_marks]#",
                        //     Cell5Data: "#[que_24_marks]#",
                        //     Cell6Data: "#[section_6_maturity_percentage]#%",
                        // },

                    ],
                    Calculations: {
                        Cell1: "Overall Percentage",
                        Cell2: "#[overall_percentage]#",
                    },
                },
                render: ({ Table, Headings, ColumnSettings, items, Calculations }) => {

                    return (
                        <>
                            <div className="table-wrap">
                                <div className="table-responsive">
                                    <table class="table">
                                        {Table.FirstRow && <thead>
                                            <tr>
                                                <th scope="col" style={{ width: `${ColumnSettings.FirstColSpan}'px'` }}>{Headings.Cell1}</th>
                                                <th scope="col" style={{ width: `${ColumnSettings.SecondColSpan}px` }} >{Headings.Cell2}</th>
                                                <th scope="col" style={{ width: `${ColumnSettings.ThirdColSpan}px` }}>{Headings.Cell3}</th>
                                                <th scope="col" style={{ width: `${ColumnSettings.FourthColSpan}px` }}>{Headings.Cell4}</th>
                                                <th scope="col" style={{ width: `${ColumnSettings.FifthColSpan}px` }}>{Headings.Cell5}</th>
                                                <th scope="col" style={{ width: `${ColumnSettings.SixthColSpan}px` }}>{Headings.Cell6}</th>
                                            </tr>
                                        </thead>}

                                        <tbody>
                                            {items.map((item, i) => (
                                                <tr key={i}>
                                                    <td>
                                                        {item.Cell1Data}
                                                    </td>


                                                    <td>
                                                        {item.Cell2Data}
                                                    </td>
                                                    <td>
                                                        {item.Cell3Data}

                                                    </td>
                                                    <td>
                                                        {item.Cell4Data}
                                                    </td>
                                                    <td>
                                                        {item.Cell5Data}
                                                    </td>
                                                    <td>
                                                        {item.Cell6Data}%
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        {Table.LastRow && <tfoot>
                                            <tr>
                                                <td>{Calculations.Cell1}</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>{Calculations.Cell2}%</td>
                                            </tr>
                                        </tfoot>}
                                    </table>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportChart: {
                fields: {
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },



                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleGraphLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadGraphLogoImage'
                                        name={name}
                                        onChange={handleGraphLogoImage}
                                    />
                                    <label htmlFor="uploadGraphLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "<span class='text-theme-primary'>#[leadForm:firstName]# #[leadForm:lastName]#</span>, here's how <span class='text-theme-primary'>#[leadForm:company]# #[survey:title]#</span> fares across the key indicators",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",


                },
                render: ({ Heading, logo }) => {

                    return (
                        <>

                            <div className="report-build-wrapper report-graph-chart-widget">
                                <div className="text wrapper flex-grow-1">

                                    <div className="rep-heading-page">
                                        <h2 className={`color-black ${Heading.fontWeight} ${Heading.titleFont}`}><div dangerouslySetInnerHTML={{ __html: Heading.title }} /></h2>
                                    </div>
                                    <div className="chart-wrapper">
                                        <DropZone zone="Chart-Zone" />
                                    </div>
                                </div>
                                <div class="stage-score-widget content-main-section section-3">
                                    {/* <div dangerouslySetInnerHTML={{ __html: Progress }} /> */}
                                    <div className="progress-wrapper section-padding-right">
                                        <DropZone zone="score-Zone" />
                                    </div>
                                </div>

                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },

            ReportMethodology: {
                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    items: {
                        type: "array",
                        label: "Sections",
                        arrayFields: {
                            Title: { type: "text" },
                            TitleFontSize: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Title font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Description: { type: "textarea" },
                            DescriptionFontSize: {
                                label: "Description font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                        getItemSummary: (item) => item.Title || "Section",
                        defaultItemProps: {
                            Title: "Section title",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            Description: "Section description",
                            DescriptionFontSize: "fs-15",
                        },
                    },
                    image: {
                        type: "custom",
                        label: "Add image (742 × 1024 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportMethoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };

                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotMethImage'
                                        name={name}
                                        onChange={handleReportMethoImage}
                                    />
                                    <label htmlFor="uploadRepotMethImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleMethLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadMethLogoImage'
                                        name={name}
                                        onChange={handleMethLogoImage}
                                    />
                                    <label htmlFor="uploadMethLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },

                },
                defaultProps: {
                    Heading: {
                        title: "02 Methodology",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        title: "Lead Indicators",
                        TitleFont: "fs-20",
                        fontWeight: "fw-700",
                        description: "Assessing enterprise threat hunting readiness, this framework scrutinizes technology integration, expertise, intelligence usage, resource allocation, and incident response to elevate security posture.",
                        descriptionFont: "fs-15",
                    },
                    items: [
                        {
                            Title: "Technology Integration",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Technology Integration evaluates an enterprise's adoption of advanced tools for threat hunting, including machine learning and cloud-based defenses."
                        },
                        {
                            Title: "Skills and Expertise",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Skills and Expertise gauge staff proficiency in threat identification, emphasizing agility in handling security data and attack methods."
                        },
                        {
                            Title: "Threat Intelligence Utilization",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Threat Intelligence Utilization reviews how organizations proactively leverage intelligence to confront evolving threats and IT complexities."
                        },
                        {
                            Title: "Budget and Resource Allocation",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Budget and Resource Allocation assesses funding and asset distribution, prioritizing specialized tools and training for threat hunting efficacy."
                        },
                        {
                            Title: "Incident Response and Coordination",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Incident Response and Coordination examines procedural efficiency post-threat detection, focusing on automation and adaptability."
                        },
                    ],

                    image: "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png",
                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",


                },
                render: ({ Heading, logo, image, items, Text }) => {

                    return (
                        <>

                            <div className="report-build-wrapper report-right-image-section">
                                <div className="text wrapper flex-grow-1">
                                    <div className="rep-heading-page">
                                        <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    </div>

                                    <div className="text-part">
                                        <div className="report-text mb__20 pb-3">
                                            <h4 className={`${Text.fontWeight} ${Text.TitleFont}`}>{Text.title}</h4>
                                            <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                        </div>
                                        <div className="list-text report-text row">
                                            {items.map((item, i) => (
                                                <div className="col-md-6" key={i}>
                                                    <div className="list-wrap mb__20 pb-2">
                                                        <h6 className={`${item.TitleFontSize} ${item.TitleFontWeight}`}>{item.Title}</h6>
                                                        <p className={`${item.DescriptionFontSize}`}>{item.Description}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="image-part" style={{ backgroundImage: `url("${image}")` }}>
                                </div>

                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },
            ReportStages: {
                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    items: {
                        type: "array",
                        label: "Sections",
                        arrayFields: {
                            Title: { type: "text" },
                            TitleFontSize: {
                                label: "Title Font",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Description: { type: "textarea" },
                            DescriptionFontSize: {
                                label: "Title Font",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                        getItemSummary: (item) => item.Title || "Section",
                        defaultItemProps: {
                            Title: "Section title",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            Description: "Section description",
                            DescriptionFontSize: "fs-15",
                        },
                    },
                    ItemsPerRow: {
                        label: "Items per row",
                        type: "select",
                        options: pucksettings['ItemsPerRow'],
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleStageLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadStageLogoImage'
                                        name={name}
                                        onChange={handleStageLogoImage}
                                    />
                                    <label htmlFor="uploadStageLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "02 Methodology",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        title: "Readiness Stage",
                        TitleFont: "fs-20",
                        fontWeight: "fw-700",
                        description: "At #[leadForm:company]#, the 'Readiness Stage' in the #[survey:title]# Assessment signifies the degree of an organization's preparedness in identifying and mitigating cyber threats. Each stage delineates the maturity and sophistication of processes, from nascent awareness to proactive, strategic operations.",
                        descriptionFont: "fs-15",
                    },
                    ItemsPerRow: '4',
                    items: [
                        {
                            Title: "Novice",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",

                            Description: "Novice entities may lack experience with threat hunting, employing reactive defense strategies and demonstrating minimal machine learning use. Their incident response may be uncoordinated with outdated tools, and threat intelligence might be underutilized, thereby necessitating foundational progress in skills and resource allocation.",
                        },
                        {
                            Title: "Emerging",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Emerging organizations are developing their threat hunting processes. They experiment with machine learning, share intelligence within communities, and utilize cloud tools for key functions. Staff have a good understanding of techniques and threat data is managed systematically, despite some reliance on manual reviews."
                        },
                        {
                            Title: "Competent",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Firms in this bracket have a structured approach to threat hunting with regular proactive exercises and strategic threat intelligence utilization. They're skilled in adapting to evolving threats and complex IT environments, with established incident response coordination and investments in specialized tools and training. "
                        },
                        {
                            Title: "Advanced",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Organizations at this stage exhibit a high level of threat hunting maturity with fully integrated machine learning and cloud-based tools. They have expert teams leading in new methods and effectively handling vast security data, while also maintaining compliance and leveraging advanced analytics to minimize manual workload."
                        },
                    ],

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, logo, items, Text, ItemsPerRow }) => {

                    return (
                        <>
                            <div className="report-build-wrapper report-stages-section">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading-page">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        </div>
                                        <div className="text-part mb__20 pb-3">
                                            <div className="report-text">
                                                <h4 className={`${Text.fontWeight} ${Text.TitleFont}`}>{Text.title}</h4>
                                                <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                            </div>
                                        </div>
                                        <div className="stages-name d-grid gap-4" style={{ gridTemplateColumns: `repeat(${ItemsPerRow}, 1fr)`, }}>
                                            {items.map((item, i) => (
                                                <div className="stages-name-wrp" key={i}>
                                                    <div className="stage-wrap">
                                                        <div className="name">
                                                            <h4 className={`${item.TitleFontSize} ${item.TitleFontWeight}`}>{item.Title}</h4>
                                                        </div>
                                                        <div className={`stage-description ${item.DescriptionFontSize}`}>
                                                            {item.Description}</div>
                                                    </div>
                                                </div>
                                            ))}


                                        </div>



                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportTechnologyIntegration: {
                fields: {

                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    Recommendations: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },


                    image: {
                        type: "custom",
                        label: "Add image (742 × 1024 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportSectionImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotSectionImage'
                                        name={name}
                                        onChange={handleReportSectionImage}
                                    />
                                    <label htmlFor="uploadRepotSectionImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportSectionLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotSectionLogoImage'
                                        name={name}
                                        onChange={handleReportSectionLogoImage}
                                    />
                                    <label htmlFor="uploadRepotSectionLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );

                        },
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "Technology Integration",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        title: "Stage: <b class='text-theme-primary'>#[maturity_stage]#</b>   | Your score:  <b class='text-theme-primary'>#[section_1_maturity_percentage]#%</b>",
                        TitleFont: "fs-25",
                        fontWeight: "fw-400",
                        description: "#[response_summary_section_1]#",
                        descriptionFont: "fs-15",
                    },
                    Recommendations: {
                        title: "",
                        TitleFont: "fs-20",
                        fontWeight: "fw-700",
                        description: "",
                        descriptionFont: "fs-15",

                    },

                    image: "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png",
                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",


                },
                render: ({ Heading, logo, image, Text, Recommendations }) => {

                    return (
                        <>

                            <div className="report-build-wrapper report-right-image-section report-recommendations img-wd-40">
                                <div className="text wrapper flex-grow-1">
                                    <div className="rep-heading-page">
                                        <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                    </div>

                                    <div className={`${Text.fontWeight} ${Text.TitleFont} stage-score mb__30`}> <div dangerouslySetInnerHTML={{ __html: Text.title }} />
                                    </div>

                                    <div className="text-part">
                                        <div className="report-text mb__20">
                                            <p className={`${Text.descriptionFont}`}><div dangerouslySetInnerHTML={{ __html: Text.description }} /></p>
                                        </div>
                                        <div className="recommendation-text">

                                            <h5 className={`${Recommendations.fontWeight} ${Recommendations.TitleFont}`}>{Recommendations.title}</h5>
                                            <div className={` ${Recommendations.descriptionFont} stage-score mb__30`}> <div dangerouslySetInnerHTML={{ __html: Recommendations.description }} />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="image-part" style={{ backgroundImage: `url("${image}")` }}>
                                </div>

                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },

            ReportTechnologyIntegration2: {
                fields: {

                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Align: {
                                label: "Text align",
                                type: "select",
                                options: pucksettings['TextAlign'],
                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            Align: {
                                label: "Text align",
                                type: "select",
                                options: pucksettings['TextAlign'],
                            },
                        },
                    },

                    Recommendations: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            Align: {
                                label: "Text align",
                                type: "select",
                                options: pucksettings['TextAlign'],
                            },
                        },
                    },

                    Solutions: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            rows={5}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },


                        },
                    },
                    items: {
                        type: "array",
                        label: "Solutions",
                        arrayFields: {
                            Title: { type: "text" },
                            TitleFontSize: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Title font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Description: { type: "textarea" },
                            DescriptionFontSize: {
                                label: "Description font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                        getItemSummary: (item) => item.Title || "Solution",
                        defaultItemProps: {
                            Title: "Solution title",
                            TitleFontSize: "fs-16",
                            TitleFontWeight: "fw-700",
                            Description: "Solution description",
                            DescriptionFontSize: "fs-15",
                        },
                    },


                    image: {
                        type: "custom",
                        label: "Add image (742 × 1024 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportSectionImage = async (e) => {
                                const file = e.target.files[0]
                                console.log("File Image", file);
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotSectionImage'
                                        name={name}
                                        onChange={handleReportSectionImage}
                                    />
                                    <label htmlFor="uploadRepotSectionImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleReportSectionLogoImage = async (e) => {
                                const file = e.target.files[0]
                                console.log("File Image", file);
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadRepotSectionLogoImage'
                                        name={name}
                                        onChange={handleReportSectionLogoImage}
                                    />
                                    <label htmlFor="uploadRepotSectionLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );

                        },
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "Technology Integration",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        title: "Stage: <b class='text-theme-primary'>#[maturity_stage]#</b>   | Your score:  <b class='text-theme-primary'>#[section_1_maturity_percentage]#%</b>",
                        TitleFont: "fs-25",
                        fontWeight: "fw-400",
                        description: "#[response_summary_section_1]#",
                        descriptionFont: "fs-15",
                    },
                    Recommendations: {
                        title: "",
                        TitleFont: "fs-20",
                        fontWeight: "fw-700",
                        description: "",
                        descriptionFont: "fs-15",
                    },
                    Solutions: {
                        title: "",
                        TitleFont: "",
                        fontWeight: "",
                    },
                    items: [],
                    image: "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png",
                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",


                },
                render: ({ Heading, logo, image, Text, Recommendations, Solutions, items }) => {
                    const areAllTitlesEmpty = (items) => {
                        return items.some(item => item.Description);
                    };
                    return (
                        <>

                            <div className="report-build-wrapper report-right-image-section report-recommendations img-wd-40">
                                <div className="text wrapper flex-grow-1">
                                    <div className="rep-heading-page">
                                        <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`} style={{ textAlign: Heading.Align }}>{Heading.title}</h2>
                                    </div>

                                    <div className={`${Text.fontWeight} ${Text.TitleFont} stage-score mb-3`} style={{ textAlign: Text.Align }}> <div dangerouslySetInnerHTML={{ __html: Text.title }} />
                                    </div>

                                    <div className="text-part" style={{ textAlign: Text.Align }}>
                                        <div className="report-text mb__20">
                                            <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                        </div>
                                        <div className="recommendation-text mb-3" style={{ textAlign: Recommendations.Align }}>
                                            <h5 className={`${Recommendations.fontWeight} ${Recommendations.TitleFont}`}>{Recommendations.title}</h5>
                                            <div className={` ${Recommendations.descriptionFont} stage-score mb__20`}> <div dangerouslySetInnerHTML={{ __html: Recommendations.description }} />
                                            </div>

                                        </div>

                                        <div className="solutions-wrap">
                                            {areAllTitlesEmpty(items) && (
                                                <div className="heading mb-1">
                                                    <h5 className={`${Solutions.fontWeight} ${Solutions.TitleFont}`}>{Solutions.title}</h5>
                                                </div>
                                            )}
                                            <div className="list-text report-text row">

                                                {items
                                                    .filter(item => item.Title && item.Description)
                                                    .map((item, i) => (
                                                        <div className="col-md-12" key={i}>
                                                            <div className="list-wrap mb-2">
                                                                <h6 className={`mb-0 ${item.TitleFontSize} ${item.TitleFontWeight}`}>{item.Title}</h6>
                                                                <p className={`mb-0 ${item.DescriptionFontSize}`}>{item.Description}</p>
                                                            </div>
                                                        </div>
                                                    ))}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="image-part" style={{ backgroundImage: `url("${image}")` }}>
                                </div>

                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </>
                    )

                },
            },

            ReportAboutCompany: {
                fields: {
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    items: {
                        type: "array",
                        label: "Sections",
                        arrayFields: {
                            Title: { type: "text" },
                            TitleFontSize: {
                                label: "Title Font",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Description: { type: "textarea" },
                            DescriptionFontSize: {
                                label: "Title Font",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                        getItemSummary: (item) => item.Title || "Section",
                        defaultItemProps: {
                            Title: "Section title",
                            TitleFontSize: "fs-22",
                            TitleFontWeight: "fw-700",
                            Description: "Section description",
                            DescriptionFontSize: "fs-15",
                        },
                    },

                    ItemsPerRow: {
                        label: "Items per row",
                        type: "select",
                        options: pucksettings['ItemsPerRow'],
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleAboutLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadAboutLogoImage'
                                        name={name}
                                        onChange={handleAboutLogoImage}
                                    />
                                    <label htmlFor="uploadAboutLogoImage" className='icon-upload'>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                },
                defaultProps: {
                    Heading: {
                        title: "Tata Communications",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        description: "Tata Communications delivers an incisive Managed Detection and Response (MDR) solution fortified with Cyber Threat Hunting to safeguard enterprises against sophisticated cyber threats. Leveraging the power of advanced analytics and machine learning, our expert-driven defense is designed to preemptively disrupt potential security breaches, ensuring organizational resilience. Our MDR service is tailored to provide continuous security monitoring, proactive threat identification, and swift, strategic responses to threats. By integrating both manual and automated processes, the solution consistently evolves to counteract both known and emerging adversaries, adeptly securing your digital environment.",
                        descriptionFont: "fs-15",
                    },
                    ItemsPerRow: '3',
                    items: [
                        {
                            Title: "Continuous Monitoring",
                            TitleFontSize: "fs-20",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Maintain vigilance with 24/7 surveillance of your network to promptly detect unusual activity and potential security breaches.",
                        },
                        {
                            Title: "Proactive Identification",
                            TitleFontSize: "fs-20",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Anticipate threats using advanced analytics, and neutralize risks before they escalate into serious attacks.",
                        },
                        {
                            Title: "Expert Defense",
                            TitleFontSize: "fs-20",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Benefit from our security experts' extensive experience to implement robust defense strategies tailored to your organization.",
                        },
                        {
                            Title: "Advanced Analytics",
                            TitleFontSize: "fs-20",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Employ cutting-edge machine learning to dissect complex security data and expose hidden threats efficiently."
                        },
                        {
                            Title: "Automated Processes",
                            TitleFontSize: "fs-20",
                            TitleFontWeight: "fw-700",
                            DescriptionFontSize: "fs-15",
                            Description: "Minimize the impact of attacks with automated responses designed to swiftly counteract intrusions."
                        },
                    ],

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, logo, items, Text, ItemsPerRow }) => {

                    return (
                        <>
                            <div className="report-build-wrapper report-stages-section">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading-page">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        </div>
                                        <div className="text-part mb__20">
                                            <div className="report-text">
                                                <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                            </div>
                                        </div>
                                        <div className="stages-name stages-no-name d-grid gap-4" style={{ gridTemplateColumns: `repeat(${ItemsPerRow}, 1fr)`, }}>
                                            {items.map((item, i) => (
                                                <div className="list-box" key={i}>
                                                    <div className="stage-wrap">
                                                        <div className="stage-description">
                                                            <h5 className={`${item.TitleFontSize} ${item.TitleFontWeight}`}>{item.Title}</h5>
                                                            <p className={`${item.DescriptionFontSize}`}>
                                                                {item.Description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}



                                        </div>
                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportQNA: {
                fields: {
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    QNASection1: {
                        label: "QNA Section 1",
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            items: {
                                type: "array",
                                label: "Questions",
                                arrayFields: {
                                    question: { type: "text" },
                                    answer: { type: "textarea" },
                                },
                                getItemSummary: (item) => item.question || "Question",
                                defaultItemProps: {
                                    question: "Question",
                                    answer: "Answer",
                                },
                            },

                        },
                    },

                    QNASection2: {
                        label: "QNA Section 2",
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            items: {
                                type: "array",
                                label: "Questions",
                                arrayFields: {
                                    question: { type: "text" },
                                    answer: { type: "textarea" },
                                },
                                getItemSummary: (item) => item.question || "Question",
                                defaultItemProps: {
                                    question: "Question",
                                    answer: "Answer",
                                },
                            },

                        },
                    },

                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleQNALogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadQNALogoImage'
                                        name={name}
                                        onChange={handleQNALogoImage}
                                    />
                                    <label htmlFor="uploadQNALogoImage" className='icon-upload'>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        },
                    },

                },
                defaultProps: {
                    Heading: {
                        title: "04 #[leadForm:company]# Assessment Responses",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    QNASection1: {
                        title: "Section title",
                        titleFont: "fs-28",
                        fontWeight: "fw-700",
                        items: [
                            {
                                question: "#[que_1_text]#",
                                answer: "#[que_1_response]#",
                            },
                            {
                                question: "#[que_2_text]#",
                                answer: "#[que_2_response]#",
                            },
                            {
                                question: "#[que_3_text]#",
                                answer: "#[que_3_response]#",
                            },
                            {
                                question: "#[que_4_text]#",
                                answer: "#[que_4_response]#",
                            },
                        ],
                    },

                    QNASection2: {
                        title: "Section title",
                        titleFont: "fs-28",
                        fontWeight: "fw-700",
                        items: [
                            {
                                question: "#[que_5_text]#",
                                answer: "#[que_5_response]#",
                            },
                            {
                                question: "#[que_6_text]#",
                                answer: "#[que_6_response]#",
                            },
                            {
                                question: "#[que_7_text]#",
                                answer: "#[que_7_response]#",
                            },
                            {
                                question: "#[que_8_text]#",
                                answer: "#[que_8_response]#",
                            },
                        ],
                    },


                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, logo, QNASection1, QNASection2 }) => {

                    return (
                        <>

                            <div className="report-build-wrapper report-qna-section">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading-page">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        </div>
                                        <div className="qna-wrapper">
                                            <div className="row">
                                                {QNASection1?.title && QNASection1?.title != undefined &&
                                                    (<div className="col-lg-6">
                                                        <div className="qna-inner">
                                                            <div className="heading">
                                                                <h4 className={`${QNASection1.fontWeight} ${QNASection1.titleFont}`}>{QNASection1.title}</h4>                                                            </div>
                                                            <div className="qna-list">
                                                                {QNASection1.items.map((item, i) => (
                                                                    <div className="qna-list-wrapper" key={i}>
                                                                        <div className={`${QNASection1.QNAFont} ${QNASection1.QNAfontWeight} question text-theme-secondary`}>{item.question}</div>
                                                                        <div className={`${QNASection1.QNAFont} ${QNASection1.QNAfontWeight} answer text-theme-primary`}>{item.answer}</div>
                                                                    </div>
                                                                ))}



                                                            </div>
                                                        </div>
                                                    </div>)
                                                }

                                                {QNASection2?.title && QNASection2?.title != undefined &&
                                                    <div className="col-lg-6">
                                                        <div className="qna-inner">
                                                            <div className="heading">
                                                                <h4 className={`${QNASection2.fontWeight} ${QNASection2.titleFont}`}>{QNASection2.title}</h4>                                                            </div>
                                                            <div className="qna-list">
                                                                {QNASection2.items.map((item, i) => (
                                                                    <div className="qna-list-wrapper" key={i}>
                                                                        <div className={`${QNASection2.QNAFont} ${QNASection2.QNAfontWeight} question text-theme-secondary`}>{item.question}</div>
                                                                        <div className={`${QNASection2.QNAFont} ${QNASection2.QNAfontWeight} answer text-theme-primary`}>{item.answer}</div>
                                                                    </div>
                                                                ))}



                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportThankYou: {
                render: ({ Header, Heading, SubHeading, Text, Button, Copyright }) => {

                    return (
                        <>
                            <div className="report-build-wrapper report-thankyou flex-column">
                                <div className="header">
                                    <div className="container">
                                        <img src={Header.logo} alt="" style={{
                                            width: `${Header.Width}px`
                                        }} />
                                    </div>
                                </div>
                                <div className="flex-grow-1 thankyou-text">
                                    <div className="container">
                                        <div className="text-wrap">
                                            <h3 className={`${Heading.Font} ${Heading.Weight}`} style={{
                                                textAlign: Heading.Align
                                            }}><div dangerouslySetInnerHTML={{ __html: Heading.Text }} /></h3>
                                            <h5 className={`${SubHeading.Font} ${SubHeading.Weight}`} style={{
                                                textAlign: SubHeading.Align
                                            }}><div dangerouslySetInnerHTML={{ __html: SubHeading.Text }} /></h5>
                                            <div className="text-part">
                                                <div className={`${Text.Font} ${Text.Weight}`} style={{
                                                    textAlign: Text.Align
                                                }}><div dangerouslySetInnerHTML={{ __html: Text.Text }} /></div>
                                            </div>
                                            <div className="button-wrap">
                                                <a href={Button.Link} target="_blank" rel="noopener noreferrer" class="btn btn-secondary d-inline-flex align-items-center" type="submit">{Button.Text}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={23} height={14} viewBox="0 0 23 14" fill="none">
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M15.2735 0.275425C15.3606 0.188119 15.464 0.118851 15.5779 0.071589C15.6918 0.024327 15.8139 0 15.9372 0C16.0605 0 16.1826 0.024327 16.2965 0.071589C16.4104 0.118851 16.5139 0.188119 16.601 0.275425L22.226 5.90042C22.3133 5.98751 22.3825 6.09096 22.4298 6.20486C22.4771 6.31876 22.5014 6.44086 22.5014 6.56418C22.5014 6.68749 22.4771 6.80959 22.4298 6.92349C22.3825 7.03738 22.3133 7.14084 22.226 7.22793L16.601 12.8529C16.4249 13.029 16.1862 13.1279 15.9372 13.1279C15.6883 13.1279 15.4495 13.029 15.2735 12.8529C15.0974 12.6769 14.9985 12.4381 14.9985 12.1892C14.9985 11.9402 15.0974 11.7015 15.2735 11.5254L20.2366 6.56418L15.2735 1.60293C15.1862 1.51584 15.1169 1.41239 15.0696 1.29849C15.0224 1.18459 14.998 1.06249 14.998 0.939175C14.998 0.815862 15.0224 0.693759 15.0696 0.579862C15.1169 0.465965 15.1862 0.362511 15.2735 0.275425Z" fill="currentColor" />
                                                        <path fillRule="evenodd" clipRule="evenodd" d="M0 6.56445C0 6.31581 0.0987722 6.07736 0.274588 5.90154C0.450403 5.72573 0.68886 5.62695 0.9375 5.62695H20.625C20.8736 5.62695 21.1121 5.72573 21.2879 5.90154C21.4637 6.07736 21.5625 6.31581 21.5625 6.56445C21.5625 6.81309 21.4637 7.05155 21.2879 7.22737C21.1121 7.40318 20.8736 7.50195 20.625 7.50195H0.9375C0.68886 7.50195 0.450403 7.40318 0.274588 7.22737C0.0987722 7.05155 0 6.81309 0 6.56445Z" fill="currentColor" />
                                                    </svg>

                                                </a>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="footer-text">
                                    <div className="container">
                                        <p className={`${Copyright.Font} ${Copyright.Weight}`} style={{
                                            textAlign: Copyright.Align
                                        }}><div dangerouslySetInnerHTML={{ __html: Copyright.Text }} /></p>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Chart: {
                fields: {
                    Setup: {
                        type: "object",
                        objectFields: {
                            CustomVariables: {
                                type: "array",
                                label: "Custom Variables",
                                getItemSummary: (item) => item.label || "Custom Variables",
                                arrayFields: {
                                    name: {
                                        type: "select",
                                        options: [
                                            { label: "Option 1", value: "Option 1" },
                                            { label: "Option 2", value: "Option 2" },
                                            { label: "Option 3", value: "Option 3" },
                                            { label: "Option 4", value: "Option 4" },
                                        ],
                                    },

                                },
                                defaultItemProps: {
                                    name: "Option 1",
                                },

                            },

                        },
                    },
                    Style: {
                        type: "object",
                        objectFields: {
                            ChartColor: { type: "text" },
                            IndicatorTitleColor: { type: "text" },
                        },
                    },
                },
                defaultProps: {
                    CustomVariables: [],
                    chartOption: {
                        radar: {
                            indicator: [
                                // { name: 'Sales', max: 6500, color: '#000000' },
                                // { name: 'Administration', max: 16000, color: '#000000' },
                                // { name: 'Information Techology', max: 30000, color: '#000000' },
                                // { name: 'Customer Support', max: 38000, color: '#000000' },
                                // { name: 'Development', max: 52000, color: '#000000' },
                                // { name: 'Marketing', max: 25000, color: '#000000' }

                            ],
                            nameGap: 20,
                            center: ['50%', '60%'],
                            radius: [0, 150]
                        },
                        series: [{
                            type: 'radar',
                            color: themeSet['--da-primary'],
                            areaStyle: {
                                color: themeSet['--da-primary'],
                            },
                            data: [
                                {
                                    value: [],
                                }
                            ]
                        }]
                    }
                },
                render: ({ chartOption }) => (
                    <>
                        <div className="echart-wrapper">
                            <ReactEcharts
                                style={{
                                    height: '350px',
                                    width: '100%',
                                }}
                                option={chartOption} />
                        </div>
                    </>
                ),
            },

            Scale: {
                fields: {
                    Setup: {
                        type: "object",
                        objectFields: {
                            Title: {
                                type: "text",
                            },
                            Name: {
                                type: "text",
                            },
                            Score: {
                                type: "custom",
                                label: "Score",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input
                                            readOnly
                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                        },
                    },
                    LeadIndicators: {
                        type: "array",
                        getItemSummary: (item) => item.label || "Lead Indicator",
                        arrayFields: {
                            name: {
                                type: "select",
                                options: [
                                    // { label: "Option 1", value: "Option 1" },
                                    // { label: "Option 2", value: "Option 2" },
                                    // { label: "Option 3", value: "Option 3" },
                                    // { label: "Option 4", value: "Option 4" },
                                ],
                            },
                            CustomVariable: {
                                type: "custom",
                                label: "Custom Variable",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input
                                            readOnly
                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                        },
                        defaultItemProps: {
                        },
                    },
                    Text: {
                        type: "object",
                        objectFields: {
                            TitleFont: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            TitleFontWeight: {
                                label: "Title font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            TitleColor: {
                                type: "custom",
                                label: "Title Color",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                            StageNameFont: {
                                label: "Stage name font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            StageNameFontWeight: {
                                label: "Stage name font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            StageNameColor: {
                                type: "custom",
                                label: "Stage name Color",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                            ScoreFont: {
                                label: "Score font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            ScoreFontWeight: {
                                label: "Score font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            ScoreColor: {
                                type: "custom",
                                label: "Score Color",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            IndicatorFont: {
                                label: "Indicator font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            IndicatorFontWeight: {
                                label: "Indicator font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            IndicatorColor: {
                                type: "custom",
                                label: "Indicator Color",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                            IndicatorScoreFont: {
                                label: "Indicator Score font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            IndicatorScoreFontWeight: {
                                label: "Indicator Score font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            IndicatorScoreColor: {
                                type: "custom",
                                label: "Indicator Score Color",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <input

                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                        }
                    },
                },
                defaultProps: {
                    Setup: {
                        Title: "Stage",
                        Name: "#[maturity_stage]#",
                        Score: "#[overall_percentage]#"
                    },
                    LeadIndicators: [
                        {
                            name: "Lead Indicator",
                            CustomVariable: "10"
                        }
                    ],


                    Text: {
                        TitleFont: "fs-16",
                        TitleFontWeight: "fs-400",
                        TitleColor: "#e0e0e0",

                        StageNameFont: "fs-46",
                        StageNameFontWeight: "fw-700",
                        StageNameColor: "#ffffff",

                        ScoreFont: "fs-60",
                        ScoreFontWeight: "fw-400",
                        ScoreColor: "#fff",

                        IndicatorFont: "fs-18",
                        IndicatorFontWeight: "fs-500",
                        IndicatorColor: "#ffffff",

                        IndicatorScoreFont: "fs-18",
                        IndicatorScoreFontWeight: "fs-400",
                        IndicatorScoreColor: "#ffffff",
                    },

                },
                render: ({ LeadIndicators, Setup, Text }) => {

                    return (
                        <>

                            {/**Scale Widget Starts **/}

                            <div className="progress-heading">
                                <div className="heading-text">
                                    <p className={`${Text.TitleFont} ${Text.TitleFontWeight}`} style={{ color: Text.TitleColor }}>{Setup.Title}</p>
                                    <h3 className={`${Text.StageNameFont} ${Text.StageNameFontWeight}`} style={{ color: Text.StageNameColor }}>{Setup.Name}</h3>
                                </div>
                                <div className={`percentage ${Text.ScoreFont} ${Text.ScoreFontWeight}`} style={{ color: Text.ScoreColor }}>{Setup.Score}%</div>
                            </div>
                            <div className="progress-chart">
                                {LeadIndicators.map((indicator, i) => (

                                    <div className="progress-list">

                                        <div className="progress-wrap" key={i}>
                                            <div className="heading ">
                                                <div className={`pro-title ${Text.IndicatorFont} ${Text.IndicatorFontWeight}`} style={{ color: Text.IndicatorColor }}>{indicator.name}</div>

                                                <div className={`value ${Text.IndicatorScoreFont} ${Text.IndicatorScoreFontWeight}`} style={{ color: Text.IndicatorScoreColor }}>{indicator.CustomVariable}%</div>
                                            </div>
                                            <div className="progress">
                                                <div className="progress-bar" role="progressbar" style={{ width: `${indicator.CustomVariable}%` }}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/* <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">Business</div>
                                        <div className="value">72%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '72%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">People</div>
                                        <div className="value">52%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '52%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">Operating Model</div>
                                        <div className="value">88%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '88%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">Infrastructure</div>
                                        <div className="value">60%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '60%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">Network</div>
                                        <div className="value">64%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '64%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="progress-list">

                                <div className="progress-wrap">
                                    <div className="heading ">
                                        <div className="pro-title">Security</div>
                                        <div className="value">20%</div>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" role="progressbar" style={{ width: '20%' }}>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            </div>
                            {/**Scale Widget Ends **/}

                        </>
                    )

                },
            },

            Solutions: {
                fields: {
                    PageNumber: {
                        type: "number"
                    },
                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            TitleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    CenterHeading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },
                            Align: {
                                label: "Text align",
                                type: "select",
                                options: pucksettings['TextAlign'],
                            },

                        },
                    },


                    logo: {
                        type: "custom",
                        label: "Add logo (195 × 12 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleSolutionLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadSolutionLogoImage'
                                        name={name}
                                        onChange={handleSolutionLogoImage}
                                    />
                                    <label htmlFor="uploadSolutionLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                },
                defaultProps: {
                    PageNumber: "",
                    Heading: {
                        title: "Solutions",
                        fontWeight: "fw-700",
                        titleFont: "fs-60",
                    },
                    Text: {
                        title: "Platforms are Living Systems",
                        TitleFont: "fs-20",
                        fontWeight: "fw-700",
                        description: "At #[leadForm:company]#, the 'Readiness Stage' in the #[survey:title]# Assessment signifies the degree of an organization's preparedness in identifying and mitigating cyber threats. Each stage delineates the maturity and sophistication of processes, from nascent awareness to proactive, strategic operations.",
                        descriptionFont: "fs-15",
                    },

                    CenterHeading: {
                        title: "Value Added Services",
                        fontWeight: "fw-700",
                        titleFont: "fs-40",
                        Align: 'center',
                    },

                    logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                },
                render: ({ Heading, logo, Text, CenterHeading }) => {

                    return (
                        <>
                            <div className="report-build-wrapper report-stages-section">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading-page">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`}>{Heading.title}</h2>
                                        </div>

                                        <div className="text-part mb__20">
                                            <div className="report-text">
                                                <h4 className={`${Text.fontWeight} ${Text.TitleFont}`}>{Text.title}</h4>
                                                <p className={`${Text.descriptionFont}`}>{Text.description}</p>
                                            </div>
                                        </div>

                                        <div className="centerheading mb-3 mb-md-4">
                                            <h3 className={`${CenterHeading.fontWeight} ${CenterHeading.titleFont}`}
                                                style={{
                                                    textAlign: CenterHeading.Align
                                                }}>{CenterHeading.title}</h3>
                                        </div>


                                        <DropZone zone="columns-dropzone" allow={["Columns"]} />

                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Columns: {
                fields: {
                    distribution: {
                        type: "radio",
                        options: [
                            { value: "auto", label: "Auto", },
                            { value: "manual", label: "Manual", },
                        ],
                    },

                    gap: {
                        label: "Column gap",
                        type: "number",
                    },

                    columns: {
                        type: "array",
                        getItemSummary: (col, id) =>
                            `Column ${id + 1}, span ${col.span ? Math.max(Math.min(col.span, 12), 1) : "auto"
                            }`,
                        arrayFields: {
                            span: {
                                label: "Span (1-12)",
                                type: "number",
                                min: 0,
                                max: 12,
                            },
                            backgroundColor: {
                                type: "text",
                                label: "Background color",
                            }
                        },
                    },
                },
                defaultProps: {
                    distribution: "auto",
                    //vertical: "align-items-center",
                    gap: 20,
                    columns: [{}, {}, {}],
                },

                render: ({ columns, distribution, vertical, gap, backgroundColor }) => {

                    return (
                        <div
                            className={`d-grid section-column mb-4 mb-md-5`}
                            style={{

                                gridTemplateColumns:
                                    distribution === "manual"
                                        ? "repeat(12, 1fr)"
                                        : `repeat(${columns.length}, 1fr)`,
                                gridColumnGap: `${gap}px`
                            }}
                        >
                            {columns.map(({ span, backgroundColor }, idx) => (
                                <div
                                    key={idx}
                                    className="w-100"
                                    style={{
                                        display: "flex",
                                        backgroundColor: backgroundColor,
                                        flexDirection: "column",
                                        gridColumn:
                                            span && distribution === "manual"
                                                ? `span ${Math.max(Math.min(span, 12), 1)}`
                                                : "",
                                    }}
                                >
                                    <DropZone
                                        zone={`column-${idx}`}
                                    // disallow={["Section"]}
                                    />
                                </div>
                            ))}
                        </div>
                    )

                },

            },

            SolutionsCard: {
                fields: {
                    TopIcon: {
                        type: "custom",
                        label: "Top icon (48 × 48 px)",
                        render: ({ name, onChange, value, field }) => {
                            const handleSolutionCardLogoImage = async (e) => {
                                const file = e.target.files[0]
                                if (!file) {
                                    toast.error('Please select a file.');
                                    return;
                                }
                                const params = {
                                    ACL: 'public-read',
                                    Body: file,
                                    Bucket: S3_BUCKET,
                                    Key: 'reportImg/Images/' + file.name
                                };
                                const uploadRequest = myBucket.putObject(params);
                                uploadRequest.on('httpUploadProgress', (evt) => {
                                    //toast.success(Math.round((evt.loaded / evt.total) * 100) + '%');
                                });
                                uploadRequest.send((err, data) => {
                                    if (err) {
                                        toast.error('Error uploading file. Please try again.');
                                    } else {
                                        const uploadedUrl = 'https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/' + file.name;
                                        onChange(uploadedUrl);
                                        toast.success('File uploaded successfully');
                                    }
                                });

                            };
                            return (
                                <>
                                    <FieldLabel label={field.label}></FieldLabel>
                                    <input
                                        type='file'
                                        className='d-none'
                                        id='uploadSolutionCardLogoImage'
                                        name={name}
                                        onChange={handleSolutionCardLogoImage}
                                    />
                                    <label htmlFor="uploadSolutionCardLogoImage" className='icon-upload' onClick={() => onChange('')}>
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label>
                                </>
                            );
                        }
                    },

                    Heading: {
                        type: "object",
                        objectFields: {
                            title: {
                                type: "custom",
                                label: "Card title",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            titleFont: {
                                label: "Title font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                            fontWeight: {
                                label: "Font weight",
                                type: "select",
                                options: pucksettings['fontweight']

                            },

                        },
                    },

                    Text: {
                        type: "object",
                        objectFields: {
                            description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            defaultValue={value}
                                            className='form-control'
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}

                                        />

                                    </>
                                ),
                            },
                            descriptionFont: {
                                label: "Font size",
                                type: "select",
                                options: pucksettings['fontsizes']

                            },
                        },
                    },

                    Lists: {
                        type: "array",
                        getItemSummary: (list) => list.Title || "List",
                        arrayFields: {
                            Image: {
                                type: "custom",
                                label: "Add icon",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>

                                        {/* <input
                                        type="file"
                                        id='uploadImage'
                                        className='d-none'
                                         defaultValue={value}
                                        name={name}
                                        onChange={(e) => onChange(e.currentTarget.value)}
                                    /> */}
                                        {/* <label htmlFor="uploadImage" className='icon-upload'>

                                        
                                        <button className='remove-btn'>
                                            <Svg name="remove-icn-roi" />
                                        </button>
                                        <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div>
                                    </label> */}
                                        <div className="position-relative upload">

                                            <button className='remove-btn'>
                                                <Svg name="remove-icn-roi" />
                                            </button>
                                            <div className="icon-upload" data-bs-toggle="modal" data-bs-target="#fileUpload">
                                                {/**Render remove button when icon is uploaded**/}
                                                <span>Upload image</span>
                                                {/* <div className="img-wrapper">
                                            <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png" className='img-fluid' alt="" />
                                        </div> */}
                                            </div>
                                        </div>


                                    </>
                                ),
                            },
                            Title: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            className='form-control'
                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },
                            Description: {
                                type: "custom",
                                label: "Text",
                                render: ({ name, onChange, value, field }) => (
                                    <>
                                        <FieldLabel label={field.label}></FieldLabel>
                                        <textarea
                                            className="form-control"
                                            defaultValue={value}
                                            name={name}
                                            onChange={(e) => onChange(e.currentTarget.value)}
                                        />

                                    </>
                                ),
                            },

                        },
                        defaultItemProps: {
                            Image: icon2,
                            Title: "Subheading",
                            Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                            ButtonLink: "#",
                            ButtonText: "Button"
                        },
                    },

                    ListSettings: {
                        type: "object",
                        objectFields: {

                            Text: {
                                type: "object",
                                objectFields: {
                                    TitleFont: {
                                        label: "Title font size",
                                        type: "select",
                                        options: pucksettings['fontsizes']
                                    },
                                    TitleFontWeight: {
                                        label: "Title font weight",
                                        type: "select",
                                        options: pucksettings['fontweight']

                                    },

                                    DescriptionFont: {
                                        label: "Description font size",
                                        type: "select",
                                        options: pucksettings['fontsizes']
                                    },
                                    DescriptionFontWeight: {
                                        label: "Description font weight",
                                        type: "select",
                                        options: pucksettings['fontweight']

                                    },

                                }
                            },



                        },
                    },
                },
                defaultProps: {
                    TopIcon: icon2,
                    Heading: {
                        title: "Solutions",
                        fontWeight: "fw-700",
                        titleFont: "fs-20",
                    },
                    Text: {
                        fontWeight: "fw-500",
                        description: "Value driven network assessment with our proven ADAIR Methodology",
                        descriptionFont: "fs-14",
                    },
                    Lists: [
                        {
                            Image: icon2,
                            Title: "Subheading one",
                            Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                        }
                    ],
                    ListSettings: {
                        Text: {
                            TitleFont: "fs-14",
                            TitleFontWeight: "fw-500",
                            DescriptionFont: "fs-12",
                            DescriptionFontWeight: "fw-400",
                        },
                    },
                },
                render: ({ TopIcon, Lists, Heading, Text, ListSettings }) => {

                    return (
                        <>
                            <div className="solutions-card-wrapper">
                                <div className="solutions-card-text text-center">
                                    {(Heading.title || Text.description) ?
                                        <div className="top-icon">
                                            <img src={TopIcon} alt="" />
                                        </div>
                                        : ""
                                    }
                                    <div className={`title ${Heading.titleFont} ${Heading.fontWeight}`}>{Heading.title}</div>
                                    <div className={`description ${Text.descriptionFont} ${Text.fontWeight}`}>{Text.description}</div>
                                </div>
                                <div className="solutions-card-list">
                                    {Lists.map((list, i) => (
                                        (list.Title || list.Description) ? (
                                            <div className="card-list-inner d-flex" key={i}>
                                                <div className="icon-inner">
                                                    <img src={list.Image} alt="" />
                                                </div>
                                                <div className="text-wrap fle-grow-1">
                                                    <h4 className={`${ListSettings.Text.TitleFont} ${ListSettings.Text.TitleFontWeight}`}>{list.Title}</h4>
                                                    <p className={`${ListSettings.Text.DescriptionFont} ${ListSettings.Text.DescriptionFontWeight}`}>{list.Description}</p>
                                                </div>
                                            </div>
                                        ) : ""
                                    ))}
                                </div>
                            </div>
                        </>
                    )

                },
            },

            /******Report Custom Components*******/
            HeaderTwoLogos: {

                render: ({ logo1, link1, logo2, link2 }) => {
                    return (
                        <div className="landing-page-wrapper">
                            <div className="header-section">
                                <div className="container">
                                    <div className={`logo-wrapper d-flex justify-content-between align-items-center`}>
                                        <Link to={link1}>
                                            <img src={logo1} alt="" />
                                        </Link>
                                        <Link to={link2}>
                                            <img src={logo2} alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                },
            },
            Section: {

                render: ({ Padding, Style, Class }) => {

                    return (
                        <>
                            <div className={`report-component-section component-section ${Class} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={{ backgroundImage: `url("${Style.Background}")`, backgroundColor: `${Style.BackgroundColor}`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                {/* <div className='overlay'></div> */}
                                <div className={`${Style.Width} position-relative`}>
                                    <DropZone zone="section" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Columns: {


                render: ({ columns, distribution, vertical, gap, Padding, Style, Border }) => {

                    return (
                        <div
                            className={`d-grid section-column ${vertical}`}
                            style={{
                                backgroundImage: `url("${Style?.Background}`,
                                backgroundColor: `${Style?.BackgroundColor}`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                borderStyle: Border?.BorderStyle,
                                borderColor: Border?.BorderColor,
                                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                borderRadius: `${Border?.BorderRadius}px`,

                                gridTemplateColumns:
                                    distribution === "manual"
                                        ? "repeat(12, 1fr)"
                                        : `repeat(${columns.length}, 1fr)`,
                                gridColumnGap: `${gap}px`
                            }}
                        >
                            {columns.map(({ span, backgroundColor }, idx) => (
                                <div
                                    key={idx}
                                    className="w-100"
                                    style={{
                                        display: "flex",
                                        backgroundColor: backgroundColor,
                                        flexDirection: "column",
                                        gridColumn:
                                            span && distribution === "manual"
                                                ? `span ${Math.max(Math.min(span, 12), 1)}`
                                                : "",
                                    }}
                                >
                                    <DropZone
                                        zone={`column-${idx}`}
                                    // disallow={["Section"]}
                                    />
                                </div>
                            ))}
                        </div>
                    )

                },

            },

            Wrapper: {

                render: ({ Padding, Style, Border, Class }) => {

                    return (
                        <>
                            <div className={`component-wrapper ${Class}`}
                                style={
                                    {
                                        backgroundImage: `url("${Style?.Background}")`,
                                        backgroundColor: `${Style?.BackgroundColor}`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                                        borderStyle: Border?.BorderStyle,
                                        borderColor: Border?.BorderColor,
                                        borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                        borderRadius: `${Border?.BorderRadius}px`,
                                    }
                                }>
                                {/* <div className='overlay'></div> */}
                                <div className={`position-relative`}>
                                    <DropZone zone="wrapper" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            Spacing: {

                render: ({ Height }) => {

                    return (
                        <div className="spacing-component" style={{ height: `${Height}` }}></div>
                    )

                },
            },

            Heading: {

                render: ({ Text, Padding }) => {

                    return (
                        <>
                            {(() => {
                                if (Text?.tag === 'h1') {
                                    return (
                                        <h1
                                            className={`section-title m-0 size-h1 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h1>
                                    );
                                }
                                else if (Text.tag === 'h2') {
                                    return (
                                        <h2
                                            className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h2>
                                    );
                                }
                                else if (Text.tag === 'h3') {
                                    return (
                                        <h3
                                            className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h3>
                                    );
                                }
                                else if (Text.tag === 'h4') {
                                    return (
                                        <h4
                                            className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h4>
                                    );
                                }
                                else if (Text.tag === 'h5') {
                                    return (
                                        <h5
                                            className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h5>
                                    );
                                }
                                else if (Text.tag === 'h6') {
                                    return (
                                        <h6
                                            className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                                            style={{
                                                color: `${Text?.Color}`,
                                                textAlign: Text?.Align,
                                                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: Text?.title }}>
                                            </div>
                                        </h6>
                                    );
                                }
                            })()}

                        </>
                    )

                },
            },

            Text: {

                render: ({ Text }) => {

                    return (
                        <>
                            <div
                                style={{
                                    color: `${Text.Color}`,
                                    textAlign: Text.Align
                                }}
                                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`} dangerouslySetInnerHTML={{ __html: Text.text }}>
                            </div>
                        </>
                    )

                },
            },

            Image: {

                render: ({ Image, AspectRatio }) => {

                    return (
                        <>
                            <div className="image-wrapper">
                                <img src={Image} alt="" className="img-fluid object-cover w-100" style={{ aspectRatio: `${AspectRatio}` }} />
                            </div>
                        </>
                    )

                },
            },

            Buttons: {

                render: ({ buttons, Align }) => {
                    return (
                        <div className={`section-button-group d-flex align-items-center gap-3 ${Align}`}>
                            {buttons.map((button, i) => (
                                <Button
                                    key={i}
                                    href={button.href}
                                    variant={button.variant}
                                    className={button.variant}
                                >
                                    {button.label}
                                </Button>
                            ))}
                        </div>

                    );
                },
            },

            ListBox1: {

                render: ({ Lists, Settings }) => {
                    return (
                        <>
                            <div className="list-box-1 d-grid gap-4" style={{ gridTemplateColumns: `repeat(${Settings.Card.ItemsPerRow}, 1fr)`, }}>
                                {Lists.map((list, i) => (
                                    <div className={`list-box-inner ${Settings.Card.IconPosition === 'left' ? 'd-flex' : ''}`}
                                        style={{
                                            borderStyle: Settings.Border.BorderStyle,
                                            borderColor: Settings.Border.BorderColor,
                                            borderWidth: `${Settings.Border.BorderWidth}px`,
                                            borderRadius: `${Settings.Border.BorderRadius}px`,
                                            backgroundColor: Settings.Card.BackgroundColor,
                                            paddingTop: `${Settings.Card.Padding.top}px`,
                                            paddingRight: `${Settings.Card.Padding.right}px`,
                                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                            paddingLeft: `${Settings.Card.Padding.left}px`,
                                            textAlign: Settings.Text.Align
                                        }}

                                        key={i}>
                                        {Settings.Card.ShowIcon ? <div className="icon-wrap">
                                            <img src={list.Image} alt="" width={Settings.Card.IconSize} />
                                        </div> : ""}

                                        <div className={`text-wrap flex-grow-1 ${Settings.Card.IconPosition === 'left' ? Settings.Card.ShowIcon && 'ps-3' : Settings.Card.ShowIcon && 'pt-3'}`}>
                                            <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight} mb-2 mb-md-3`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>

                                            <div className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>
                                                <div dangerouslySetInnerHTML={{ __html: list.Description }} />
                                            </div>


                                            {Settings.Card.ShowButton
                                                ? <div className="button-wrap pt-3">
                                                    <a className="btn btn-link d-inline-flex" style={{ color: Settings.Card.ButtonColor }} href={list.ButtonLink}>
                                                        <span>{list.ButtonText}</span> <Svg name="button-arrow" />
                                                    </a>
                                                </div>
                                                :
                                                ""}

                                        </div>
                                    </div>

                                ))}


                            </div>
                        </>
                    )
                },
            },

            StagesList: {

                render: ({ Lists, Settings }) => {
                    return (
                        <>
                            <div className="list-box-stages d-grid gap-2" style={{ gridTemplateColumns: `repeat(${Settings.Card.ItemsPerRow}, 1fr)`, }}>
                                {Lists.map((list, i) => (
                                    <div className={`list-box-inner ${Settings.Card.IconPosition === 'left' ? 'd-flex' : ''}`}
                                        style={{
                                            borderStyle: Settings.Border.BorderStyle,
                                            borderColor: Settings.Border.BorderColor,
                                            borderWidth: `${Settings.Border.BorderWidth}px`,
                                            borderRadius: `${Settings.Border.BorderRadius}px`,
                                            backgroundColor: Settings.Card.BackgroundColor,
                                            paddingTop: `${Settings.Card.Padding.top}px`,
                                            paddingRight: `${Settings.Card.Padding.right}px`,
                                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                            paddingLeft: `${Settings.Card.Padding.left}px`,
                                            textAlign: Settings.Text.Align
                                        }}

                                        key={i}>
                                        {Settings.Card.ShowIcon ? <div className="icon-wrap">
                                            <img src={list.Image} alt="" width={Settings.Card.IconSize} />
                                        </div> : ""}

                                        <div className={`text-wrap flex-grow-1 ${Settings.Card.IconPosition === 'left' ? Settings.Card.ShowIcon && 'ps-3' : Settings.Card.ShowIcon && 'pt-3'}`}>
                                            <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight} mb-2 mb-md-3`} style={{ color: Settings.Text.TitleColor }}>{list.Title}</h4>

                                            <div className={`${Settings.Text.LevelFont} ${Settings.Text.LevelFontWeight} mb-1`} style={{ color: Settings.Text.LevelColor }}>
                                                <div dangerouslySetInnerHTML={{ __html: list.Level }} />
                                            </div>
                                            <div className={`${Settings.Text.ScoreFont} ${Settings.Text.ScoreFontWeight} mb-0`} style={{ color: Settings.Text.ScoreColor }}>
                                                <div dangerouslySetInnerHTML={{ __html: list.Score }} />
                                            </div>

                                        </div>
                                    </div>

                                ))}


                            </div>
                        </>
                    )
                },
            },
            StatSection: {

                render: ({ Lists, Settings }) => {
                    return (
                        <>

                            <div className="list-box-1 d-grid gap-4" style={{ gridTemplateColumns: `repeat(${Settings.Card.ItemsPerRow}, 1fr)`, }}>
                                {Lists.map((list, i) => (
                                    <div className={`list-box-inner`} key={i}
                                        style={{
                                            borderStyle: Settings.Border.BorderStyle,
                                            borderColor: Settings.Border.BorderColor,
                                            borderWidth: `${Settings.Border.BorderTop}px ${Settings.Border.BorderRight}px ${Settings.Border.BorderBottom}px ${Settings.Border.BorderLeft}px `,
                                            borderRadius: `${Settings.Border.BorderRadius}px`,
                                            backgroundColor: Settings.Card.BackgroundColor,
                                            paddingTop: `${Settings.Card.Padding.top}px`,
                                            paddingRight: `${Settings.Card.Padding.right}px`,
                                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                            paddingLeft: `${Settings.Card.Padding.left}px`,
                                            textAlign: Settings.Text.Align
                                        }}
                                    >

                                        <div className={`text-wrap flex-grow-1`}>

                                            <h4 className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight} mb-2 mb-md-3`} style={{ color: Settings.Text.TitleColor }}>{list.Title}%</h4>

                                            {list.SubTitle && <h5 className={`${Settings.Text.SubTitleFont} ${Settings.Text.SubTitleFontWeight} mt-3 mt-lg-4 mb-1`} style={{ color: Settings.Text.SubTitleColor }}>{list.SubTitle}</h5>}


                                            <p className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }}>{list.Description}</p>
                                            {Settings.Card.ShowButton
                                                ? <div className="button-wrap pt-3">
                                                    <a className="btn btn-link d-inline-flex" style={{ color: Settings.Card.ButtonColor }} href={list.ButtonLink}>
                                                        <span>{list.ButtonText}</span> <Svg name="button-arrow" />
                                                    </a>
                                                </div>
                                                :
                                                ""}

                                        </div>
                                    </div>

                                ))}


                            </div>
                        </>
                    )
                },
            },
            QNAList: {

                render: ({ Text, items }) => {
                    return (
                        <>
                            {items.map((item, i) => (
                                <div className="qna-list-wrapper-new" key={i}>
                                    <div className={`${Text.FontSize} ${Text.fontweight} question-content`} title={item.question}>{item.question}</div>
                                    <div className={`${Text.FontSize} ${Text.fontweight} answer-content`} title={item.answer}>{item.answer}</div>
                                </div>
                            ))}

                        </>
                    )
                },
            },

            HeaderTwoLogos2: {
                render: ({ logo1, link1, logo2, link2, Settings }) => {
                    return (
                        <div className="landing-page-wrapper">
                            <div className={`header-section ${Settings.Class}`}
                                style={
                                    {
                                        backgroundImage: `url("${Settings.Background.Image}")`,
                                        backgroundColor: `${Settings.Background.Color}`,
                                        backgroundPosition: `${Settings.Background.Position}`,
                                        backgroundSize: `${Settings.Background.Size}`,
                                        backgroundRepeat: `${Settings.Background.Repeat}`,
                                        padding: `${Settings.Padding.Top}px ${Settings.Padding.Right}px ${Settings.Padding.Bottom}px ${Settings.Padding.Left}px`,
                                    }
                                }
                            >
                                <div className="container">
                                    <div className={`logo-wrapper d-flex justify-content-between ${Settings.Align}`}>
                                        {link1 ? <Link to={link1}>
                                            <img src={logo1} alt="" style={{
                                                width: `${Settings?.Logo1Width}px`,
                                            }} />
                                        </Link> : <img src={logo1} alt="" style={{
                                            width: `${Settings?.Logo1Width}px`,
                                        }} />}
                                        {link2 ? <Link to={link2}>
                                            <img src={logo2} alt="" style={{
                                                width: `${Settings?.Logo2Width}px`,
                                            }} />
                                        </Link> : <img src={logo2} alt="" style={{
                                            width: `${Settings?.Logo2Width}px`,
                                        }} />}

                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                },
            },

            Wrapper2: {

                render: ({ Padding, Background, Border, Class }) => {

                    return (
                        <>
                            <div className={`component-wrapper ${Class}`}
                                style={
                                    {
                                        backgroundImage: `url("${Background.Image}")`,
                                        backgroundColor: `${Background.Color}`,
                                        backgroundPosition: `${Background.Position}`,
                                        backgroundSize: `${Background.Size}`,
                                        backgroundRepeat: `${Background.Repeat}`,
                                        padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                        borderStyle: Border.BorderStyle,
                                        borderColor: Border.BorderColor,
                                        borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                                        borderRadius: `${Border.BorderRadius}px`,
                                    }
                                }>
                                {/* <div className='overlay'></div> */}
                                <div className={`position-relative`}>
                                    <DropZone zone="wrapper" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            ReportWhatsInside2: {
                render: ({ Heading, logo, items, Settings }) => {

                    return (
                        <>
                            <div className="report-whats-inside bg-transparent report-build-wrapper">
                                <div className="container">
                                    <div className="text wrapper">
                                        <div className="rep-heading">
                                            <h2 className={`${Heading.fontWeight} ${Heading.titleFont}`} style={{
                                                textAlign: Heading.Align
                                            }}>{Heading.title}</h2>
                                        </div>
                                        <div className="inside-main">
                                            <div className="row">
                                                {items.map((item, i) => (

                                                    <div className="col-lg-4 col-md-4" key={i}>
                                                        <div className="inside-wrapper" style={{
                                                            textAlign: Settings.Align
                                                        }}>
                                                            <h4 className={`${Settings.CouterFontSize} ${Settings.CounterFontWeight} background-clip-text`}
                                                                style={
                                                                    {
                                                                        background: `-webkit-linear-gradient(${Settings.CounterColor.Rotation}deg, ${Settings.CounterColor.Color1}, ${Settings.CounterColor.Color2})`,

                                                                        WebkitTextStroke: `${Settings.CounterColor.Stroke}px transparent`,
                                                                        color: `${Settings.CounterColor.InnerColor}`
                                                                    }
                                                                }
                                                            >{String(i + 1).padStart(2, '0')}</h4>
                                                            <p className={`${Settings.TitleFontSize}`}
                                                                style={{
                                                                    color: Settings.TitleColor
                                                                }}
                                                            >{item.Title}</p>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="report-footer-logo">
                                    <div className="container">
                                        <div className="logo-wrap">
                                            <img src={logo} alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    )

                },
            },

            Section2: {
                render: ({ Padding, Background, Settings }) => {

                    return (
                        <>
                            <div className={`report-component-section component-section ${Settings.Class} ${Padding.bottom} ${Padding.top} ${Padding.fullHeight && 'full-height'}`} style={
                                {
                                    backgroundImage: `url("${Background.Image}")`,
                                    backgroundColor: `${Background.Color}`,
                                    backgroundPosition: `${Background.Position}`,
                                    backgroundSize: `${Background.Size}`,
                                    backgroundRepeat: `${Background.Repeat}`,

                                    borderStyle: Settings?.Border?.BorderStyle,
                                    borderColor: Settings?.Border?.BorderColor,
                                    borderWidth: `${Settings?.Border?.BorderWidth?.top}px ${Settings?.Border?.BorderWidth?.right}px ${Settings?.Border?.BorderWidth?.bottom}px ${Settings?.Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Settings?.Border?.BorderRadius}px`,
                                }
                            }>
                                {/* <div className='overlay'></div> */}
                                <div className={`${Settings.Width} position-relative`}>
                                    <DropZone zone="section" />
                                </div>
                            </div>
                        </>
                    )

                },
            },

            GradientWrapper: {
                render: ({ Padding, Style, Border, Class }) => {

                    return (
                        <>
                            <div className={`gradient-border ${Class}`}
                                style={
                                    {
                                        borderRadius: Border.BorderRadius,
                                        position: 'relative',
                                        background: 'transparent',
                                        padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                                    }
                                }> <style dangerouslySetInnerHTML={
                                    { __html: " .gradient-border::before { border-radius: " + Border.BorderRadius + "px; background: linear-gradient(to right, " + Border.BorderColor1 + ", " + Border.BorderColor2 + ", " + Border.BorderColor3 + ", " + Border.BorderColor4 + "); } .gradient-border::after { background-color: " + Style?.BackgroundColor + "; margin: " + Border.BorderWidth + "px; border-radius: " + Border.BorderRadius + "px; }" }
                                } />
                                <div className={`position-relative`}
                                    style={
                                        {
                                            borderRadius: Border.BorderRadius,
                                            overflow: 'hidden'
                                        }
                                    }>
                                    <DropZone zone="wrapper" />
                                </div>
                            </div>

                        </>
                    )

                },
            },

            Icon: {
                render: ({ Icon, Size, Settings }) => {

                    return (
                        <>
                            <div className="image-wrapper">
                                <img src={Icon} alt="" className={`icon d-block ${Settings?.Align}`} style={
                                    {
                                        width: `${Size?.Width}px`,
                                        height: `${Size?.Height}px`,
                                    }
                                } />
                            </div>
                        </>
                    )

                },
            },

            eCharts: {

                render: ({ Chart, hide }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="echart-wrap" style={{ opacity: inputOpacity }}>

                                {(() => {
                                    if (Chart.chooseChart === "pie") {
                                        return <ReactEcharts style={chartStyle} option={PieChartOptions} />;
                                    } else if (Chart.chooseChart === "bar") {
                                        return <ReactEcharts style={chartStyle} option={BarChartOptions} />;
                                    } else if (Chart.chooseChart === "gauge" && Chart.gauge && Chart.gauge.gaugeValue !== undefined) {
                                        const { chartColor, textColor, min, max, interval } = Chart.gauge;
                                        const updatedOptions = updateChartOptions(GaugeChartOptiopns, Chart.gauge.gaugeValue, chartColor, textColor, min, max, interval);
                                        console.log(updatedOptions)
                                        return <div className='gauge-chrt'><ReactEcharts style={chartStyleGauge} option={updatedOptions} /></div>;
                                        // {updatePieChartOptions(GaugeChartOptiopns,Chart)}
                                    }
                                })()}

                            </div>
                        </>
                    )
                },
            },

            ListBox2: {

                render: ({ Lists, Settings }) => {
                    return (
                        <>
                            <div className="list-box-1 d-grid gap-3" style={{ gridTemplateColumns: `repeat(${Settings.Card.ItemsPerRow}, 1fr)`, }}>
                                {Lists.map((list, i) => (
                                    <div className={`list-box-inner d-flex align-items-center`}
                                        style={{
                                            borderStyle: Settings.Border.BorderStyle,
                                            borderColor: Settings.Border.BorderColor,
                                            borderWidth: `${Settings.Border.BorderWidth}px`,
                                            borderRadius: `${Settings.Border.BorderRadius}px`,
                                            backgroundColor: Settings.Card.BackgroundColor,
                                            paddingTop: `${Settings.Card.Padding.top}px`,
                                            paddingRight: `${Settings.Card.Padding.right}px`,
                                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                                            paddingLeft: `${Settings.Card.Padding.left}px`,
                                        }}

                                        key={i}>
                                        {Settings.Card.ShowIcon ? <div className="icon-wrap d-flex align-items-center">
                                            <img src={list.Image} alt="" className="icon-image" width={Settings.Card.IconSize} />
                                        </div> : ""}
                                        <div className={`text-wrap flex-grow-1 ${Settings.Card.ShowIcon ? 'ps-3' : ''}`}>

                                            {list.Description && <div className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`} style={{ color: Settings.Text.DescriptionColor }} dangerouslySetInnerHTML={{ __html: list.Description }}></div>}

                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )
                },
            },

            Button: {
                render: ({ buttonAction, buttonText, conditionalLogic, buttonLink, iconPosition, buttonStyle, buttonicon, icon, hide, customStyle, Style, spacing, IconSize }) => {
                    // Calculate opacity based on hide value
                    const inputOpacity = hide ? 0.5 : 1;

                    return (
                        <>
                            <div className="button-wrap" style={{ opacity: inputOpacity }}>
                                {buttonicon === "yes" ?


                                    (() => {
                                        if (buttonAction == 1) {
                                            return (
                                                <button actions={`${buttonAction}`} onClick={() => { setFlagLandingPage(1); }}
                                                    className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit"
                                                    style={
                                                        customStyle ?
                                                            {
                                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                                color: `${Style?.Font?.Color}`,
                                                                padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                                margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                                                borderStyle: Style?.Border?.BorderStyle,
                                                                borderColor: Style?.Border?.BorderColor,
                                                                borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                                borderRadius: `${Style?.Border.BorderRadius}px`,
                                                                gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                            }
                                                            : {
                                                                gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                            }
                                                    }
                                                >
                                                    {(() => {
                                                        if (iconPosition === "left") {
                                                            if (customStyle) {
                                                                return (<> <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /> {buttonText} </>)
                                                            }
                                                            else {
                                                                return (<> <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /> {buttonText}</>)
                                                            }

                                                        } else if (iconPosition === "right") {
                                                            if (customStyle) {
                                                                return (<> {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } />  </>)
                                                            }
                                                            else {
                                                                return (<>  {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /></>)
                                                            }
                                                        }
                                                        else {
                                                            return (<>  {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                {
                                                                    width: `${IconSize?.Width}px`,
                                                                    height: `${IconSize?.Height}px`,
                                                                }
                                                            } /></>)
                                                        }
                                                    })()}

                                                </button>

                                            )
                                        }
                                        else {
                                            return (
                                                <a href={`${buttonLink}`} target='_blank' actions={`${buttonAction}`}
                                                    className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit"
                                                    style={
                                                        customStyle ?
                                                            {
                                                                backgroundColor: `${Style?.BackgroundColor}`,
                                                                color: `${Style?.Font?.Color}`,
                                                                padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                                margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                                                borderStyle: Style?.Border?.BorderStyle,
                                                                borderColor: Style?.Border?.BorderColor,
                                                                borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                                borderRadius: `${Style?.Border.BorderRadius}px`,
                                                                gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                            }
                                                            : {
                                                                gap: `${spacing ? `${spacing}px` : '20px'}`,
                                                            }
                                                    }
                                                >
                                                    {(() => {
                                                        if (iconPosition === "left") {
                                                            if (customStyle) {
                                                                return (<> <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /> {buttonText} </>)
                                                            }
                                                            else {
                                                                return (<> <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /> {buttonText}</>)
                                                            }

                                                        } else if (iconPosition === "right") {
                                                            if (customStyle) {
                                                                return (<> {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } />  </>)
                                                            }
                                                            else {
                                                                return (<>  {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                    {
                                                                        width: `${IconSize?.Width}px`,
                                                                        height: `${IconSize?.Height}px`,
                                                                    }
                                                                } /></>)
                                                            }
                                                        }
                                                        else {
                                                            return (<>  {buttonText} <img src={icon} alt="" className={`btn-icon`} style={
                                                                {
                                                                    width: `${IconSize?.Width}px`,
                                                                    height: `${IconSize?.Height}px`,
                                                                }
                                                            } /></>)
                                                        }
                                                    })()}

                                                </a>
                                            )
                                        }
                                    })()


                                    :

                                    (() => {
                                        if (buttonAction == 1) {
                                            return (
                                                <button actions={`${buttonAction}`} onClick={() => {

                                                    setFlagLandingPage(1);

                                                }} className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit" style={
                                                    customStyle ?
                                                        {
                                                            backgroundColor: `${Style?.BackgroundColor}`,
                                                            color: `${Style?.Font?.Color}`,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,

                                                        }
                                                        : {}
                                                }>{buttonText}</button>
                                            )
                                        }
                                        else {
                                            return (
                                                <a href={`${buttonLink}`} target='_blank' actions={`${buttonAction}`} className={`btn roi-btn-${buttonStyle} ${customStyle ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}` : ''}`} type="submit" style={
                                                    customStyle ?
                                                        {
                                                            backgroundColor: `${Style?.BackgroundColor}`,
                                                            color: `${Style?.Font?.Color}`,
                                                            padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                                            margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                                            borderStyle: Style?.Border?.BorderStyle,
                                                            borderColor: Style?.Border?.BorderColor,
                                                            borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                                            borderRadius: `${Style?.Border.BorderRadius}px`,

                                                        }
                                                        : {}
                                                }>{buttonText}</a>
                                            )
                                        }
                                    })()

                                }

                            </div>
                        </>
                    )

                },
            },
            ReportPagination: {
                render: ({ Text }) => {

                    return (
                        <>
                            <div
                                style={{
                                    color: `${Text.Color}`
                                }}
                                className={`pagination-text m-0 ${Text.FontWeight} ${Text.FontSize} ${Text.CustomClass} `} dangerouslySetInnerHTML={{ __html: Text.text }}>
                            </div>
                        </>
                    )

                },
            },

            ProgressBar: {
              
                render: ({
                    useDynamic = true,
                    dynamicExpression = "",
                    dynamicValue = 50,
                    userValue = 0,
                    showPercentage = true,
                    Color1 = "#FF5A5A",
                    Color2 = "#FF9F43",
                    Color3 = "#28C76F",
                    Style = {},
                  }) => {
                    // Use surveyReportData.quesDom for dynamic expressions if useDynamic is true
                    let progressValue;
                    if (useDynamic) {
                      // Use the global surveyReportData.quesDom for replacement
                      progressValue = Number(replaceDynamicExpressions(dynamicExpression, surveyReportData.quesDom));
                      // Fallback to 0 if not a valid number
                      if (isNaN(progressValue)) progressValue = 0;
                    } else {
                      progressValue = userValue;
                    }
                    const colors = [Color1, Color2, Color3];
            
                    return (
                      <div style={{ width: "100%", padding: "24px 0" }}>
                        {/* Progress Bar */}
                        <div
                          style={{
                            position: "relative",
                            height: Style.Height || 16,
                            borderRadius: Style.BorderRadius || 8,
                            background: "#222",
                          }}
                        >
                          {/* Gradient Segments */}
                          <div style={{ display: "flex", height: "100%", overflow: "hidden", borderRadius: "inherit", }}>
                            <div style={{ width: "33.33%", background: colors[0], height: "100%" }} />
                            <div style={{ width: "33.33%", background: colors[1], height: "100%" }} />
                            <div style={{ width: "33.34%", background: colors[2], height: "100%" }} />
                          </div>
            
                          {/* White arrow indicator */}
                          <div
                            style={{
                              position: "absolute",
                              left: `calc(${progressValue}% - ${(Style.ArrowWidth || 5) / 2}px)`,
                              top: Style.ArrowTop || -14,
                              width: Style.ArrowWidth || 5,
                              height: Style.ArrowHeight || 44,
                              border: `${Style.ArrowBorder || 5}px solid #fff`,
                              borderRadius: 50,
                            }}
                          />
            
            
                          {/* Percentage Text */}
                          {showPercentage && (
                            <div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                                color: "#fff",
                                fontWeight: "bold",
                                zIndex: 1,
                              }}
                            >
                              {progressValue}%
                            </div>
                          )}
                        </div>
            
                        {/* Optional Below Value Display */}
                        {/* <div style={{ textAlign: "center", marginTop: 8, color: "#fff" }}>
                          Value: <span style={{ fontWeight: "bold" }}>{progressValue}</span>
                        </div> */}
                      </div>
                    );
                  },
              },

        },
    };

    const SectionData = {
        "content": [
            {
                "type": "Solutions",
                "props": {
                    "PageNumber": "",
                    "Heading": {
                        "title": "Solutions",
                        "fontWeight": "fw-700",
                        "titleFont": "fs-60"
                    },
                    "Text": {
                        "title": "Platforms are Living Systems",
                        "TitleFont": "fs-20",
                        "fontWeight": "fw-700",
                        "description": "At #[leadForm:company]#, the 'Readiness Stage' in the #[survey:title]# Assessment signifies the degree of an organization's preparedness in identifying and mitigating cyber threats. Each stage delineates the maturity and sophistication of processes, from nascent awareness to proactive, strategic operations.",
                        "descriptionFont": "fs-15"
                    },
                    "CenterHeading": {
                        "title": "Value Added Services",
                        "fontWeight": "fw-700",
                        "titleFont": "fs-40",
                        "Align": "center"
                    },
                    "logo": "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
                    "id": "Solutions-3dc8c1cc-1464-4f53-acb6-71a17724aef9"
                }
            }
        ],
        "root": {},
        "zones": {
            "Columns-7a36ef8a-2c7e-4548-a4ab-a3216edb6128:column-0": [
                {
                    "type": "SolutionsCard",
                    "props": {
                        "TopIcon": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                        "Heading": {
                            "title": "Solutions",
                            "fontWeight": "fw-700",
                            "titleFont": "fs-20"
                        },
                        "Text": {
                            "fontWeight": "fw-500",
                            "description": "Value driven network assessment with our proven ADAIR Methodology",
                            "descriptionFont": "fs-16"
                        },
                        "Lists": [
                            {
                                "Image": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                                "Title": "Subheading one",
                                "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                            },
                            {
                                "Image": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                                "Title": "Subheading",
                                "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                                "ButtonLink": "#",
                                "ButtonText": "Button"
                            },
                            {
                                "Image": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                                "Title": "Subheading",
                                "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.",
                                "ButtonLink": "#",
                                "ButtonText": "Button"
                            }
                        ],
                        "ListSettings": {
                            "Text": {
                                "TitleFont": "fs-16",
                                "TitleFontWeight": "fw-500",
                                "DescriptionFont": "fs-15",
                                "DescriptionFontWeight": "fw-400"
                            }
                        },
                        "id": "SolutionsCard-15ba9a2f-d656-4a33-8594-d10982018f38"
                    }
                }
            ],
            "Columns-7a36ef8a-2c7e-4548-a4ab-a3216edb6128:column-1": [
                {
                    "type": "SolutionsCard",
                    "props": {
                        "TopIcon": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                        "Heading": {
                            "title": "Solutions",
                            "fontWeight": "fw-700",
                            "titleFont": "fs-20"
                        },
                        "Text": {
                            "fontWeight": "fw-500",
                            "description": "Value driven network assessment with our proven ADAIR Methodology",
                            "descriptionFont": "fs-16"
                        },
                        "Lists": [
                            {
                                "Image": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                                "Title": "Subheading one",
                                "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                            }
                        ],
                        "ListSettings": {
                            "Text": {
                                "TitleFont": "fs-16",
                                "TitleFontWeight": "fw-500",
                                "DescriptionFont": "fs-15",
                                "DescriptionFontWeight": "fw-400"
                            }
                        },
                        "id": "SolutionsCard-5082c6a6-46e5-4839-afef-73a8e7d12c8f"
                    }
                }
            ],
            "Columns-7a36ef8a-2c7e-4548-a4ab-a3216edb6128:column-2": [
                {
                    "type": "SolutionsCard",
                    "props": {
                        "TopIcon": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                        "Heading": {
                            "title": "Solutions",
                            "fontWeight": "fw-700",
                            "titleFont": "fs-20"
                        },
                        "Text": {
                            "fontWeight": "fw-500",
                            "description": "Value driven network assessment with our proven ADAIR Methodology",
                            "descriptionFont": "fs-16"
                        },
                        "Lists": [
                            {
                                "Image": "/static/media/icon.3b2beb1a8cd2ed8982f7918cb839c48f.svg",
                                "Title": "Subheading one",
                                "Description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros."
                            }
                        ],
                        "ListSettings": {
                            "Text": {
                                "TitleFont": "fs-16",
                                "TitleFontWeight": "fw-500",
                                "DescriptionFont": "fs-15",
                                "DescriptionFontWeight": "fw-400"
                            }
                        },
                        "id": "SolutionsCard-9031675b-f729-4a25-9ace-8c59dbe2516f"
                    }
                }
            ],
            "Solutions-3dc8c1cc-1464-4f53-acb6-71a17724aef9:columns-dropzone": [
                {
                    "type": "Columns",
                    "props": {
                        "distribution": "auto",
                        "vertical": "align-items-start",
                        "gap": 20,
                        "columns": [
                            {},
                            {},
                            {}
                        ],
                        "id": "Columns-7a36ef8a-2c7e-4548-a4ab-a3216edb6128"
                    }
                }
            ]
        }
    }
    return (
        <>
            {/* <Render config={config} data={SectionData} /> */}

            <div dangerouslySetInnerHTML={{ __html: "<style type='text/css'> :root { --font-family: " + themeSet['--font-family'] + "; --theme-primary: " + themeSet['--da-primary'] + " !important;--da-primary: " + themeSet['--da-primary'] + " !important; --da-secondary: " + themeSet['--da-secondary'] + " !important;--theme-secondary: " + themeSet['--da-secondary'] + " !important; --progress-1: " + themeSet['--progress-1'] + " !important; --progress-2: " + themeSet['--progress-2'] + " !important; --progress-3: " + themeSet['--progress-3'] + " !important; --progress-4: " + themeSet['--progress-4'] + " !important; --progress-5: " + themeSet['--progress-5'] + " !important; } </style>" }} />
            <div className="page-wrapper" id='surveyReport'>
                {innerHtml1?.map((html, index) => {
                    // const processedHtml = DynamicEChartsRenderer(html);
                    //{DynamicEChartsRenderer(html)}
                    //console.log("html", html)
                    return (
                        <Render
                            config={config}
                            data={JSON.parse(html)}
                        />

                    )
                })}
            </div>
        </>
    )
}
